import {Component, ElementRef, OnDestroy, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {
  DialogFormInput,
  DialogsService,
  faSpellCheck,
  LangService,
  LoaderService,
  NavigateService,
  ShortcutAction
} from 'ngx-satoris';
import {ApiService} from '../../../shared/services/api.service';
import {
  addDays,
  addMilliseconds,
  addMonths,
  differenceInDays, differenceInHours, endOfDay,
  format,
  isBefore,
  isEqual,
  parse,
  parseISO,
  startOfDay,
  startOfToday
} from 'date-fns';
import {Place} from '../../../shared/models/place';
import {isJsonParsable} from 'src/app/shared/utils/parseMetadata';
import {DocumentType, Gender, MaritalStatus, UserPermission, UserPlatformRole} from 'src/app/shared/models/user';
import {UiPermission} from 'src/app/shared/models/permission';
import {
  ActionState,
  ConsumeMode,
  ConsumeRequestData,
  CurrencySign,
  DataGroup,
  DocumentCode,
  NoticeType,
  OperationType,
  PassFields,
  PassFieldsData,
  PassportType,
  PrintApprovalLetterData,
  PrintBorderpassData,
  PrintReceiptData,
  PrintDecisionLetterData,
  RequestCashType,
  RequestState,
  RequestSubState,
  RequestType,
  RequestWithDuplicata,
  WatchlistMatch
} from 'src/app/shared/models/request';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {environment} from 'src/environments/environment';
import {FormField, SelectOption, TRAVEL_NUM_BY_MODE, VisaFN, VisaFormConfig, VisaFormName} from 'src/app/shared/models/forms';
import {PlatformEvent, PlatformEventType} from 'src/app/shared/models/information';
import {QrService} from 'src/app/shared/services/qr.service';
import {CartService, FormApplication} from 'src/app/shared/services/cart.service';
import {RequestService} from 'src/app/shared/services/request.service';
import {ScanDocumentService} from 'src/app/shared/services/scan-document.service';
import {cleanDate, convertToEpoch, convertToYYMMDD} from 'src/app/shared/utils/date';
import {hasValue} from 'src/app/shared/utils/form';
import {Subscription} from 'rxjs';
import * as uuid from 'uuid';
import {isBase64, isPDF, mergeDocuments} from 'src/app/shared/utils/file';
import {compressFile} from 'src/app/shared/utils/compressImage';
import {FingerprintService} from '../../../shared/services/fingerprint.service';
import {DialogDocViewerComponent} from '../../../components/dialogs/dialog-doc-viewer/dialog-doc-viewer.component';
import {QueueService} from '../../../shared/services/queue.service';
import {SyncService} from '../../../shared/services/sync.service';
import {
  DialogEditPassportComponent
} from 'src/app/components/dialogs/dialog-edit-passport/dialog-edit-passport.component';
import {PaymentService} from '../../../shared/services/payment.service';
import {PlacesService} from '../../../shared/services/places.service';
import {isEmptyObject} from 'src/app/shared/utils/object';
import {PrintService} from 'src/app/shared/services/print.service';
import {
  AllDocumentsPrintType,
  DocsPrintType,
  PrintApplicationData,
  PrintNoticeData,
  PrintNoticeRestrictionData, PrintSingleDocument
} from 'src/app/shared/models/print';
import {Store} from 'src/app/shared/models/store';
import {StorageService} from 'src/app/shared/services/storage.service';
import {ApiCall} from '../../../shared/models/queue';
import {formatInternalReference} from 'src/app/shared/utils/string';
import {mustBeDifferentValidator, dateMilliFromNowValidator} from 'src/app/shared/utils/validators';
import {canHaveDocuments, canPrintSticker, checkVisaPreconditions, isCanHaveOnArrival, isRequirePreapproval, evaluateCanBeAcceptedRefused, getCountries, evaluateCanBeReviewed, loadFormConfigs, getFormConfig, hasUiPerm, documentTypeIsVisaExtAB, documentTypeIsVisaExtC, documentTypeIsAnyExtension} from 'src/app/shared/models/default-filter-strategy';
import {getEnumByRole} from 'src/app/shared/utils/getEnumByRole';
import {enumToArrayObjectSelect} from 'src/app/shared/utils/enumToArrayObject';
import {FieldRecords} from 'mrz';
import {DialogBookTimeSlotComponent} from 'src/app/components/dialogs/dialog-book-time-slot/dialog-book-time-slot.component';
import {documentTypeIsAnyVisa, documentTypeIsEntry, documentTypeIsExit, documentTypeIsIdentityCard, documentTypeIsPassport, documentTypeIsProvisionalResidencePermit, documentTypeIsResidenceCard, documentTypeIsVisa, documentTypeIsVisaDouble, documentTypeIsVisaMultiple, getDocumentTypeIsBorderPass, getDocumentTypeIsVisa, getDocumentTypeIsVisaDouble} from 'src/app/shared/models/document-type-helpers';

declare const window: any;

interface Difference {
  key: PassFields;
  scanNorm: string;
  metaNorm: string;
}

@Component({
  selector: 'app-admin-request-select',
  templateUrl: './admin-request-select.component.html',
  styleUrls: ['./admin-request-select.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminRequestSelectComponent implements OnDestroy {
  paymentId: string;
  current: RequestWithDuplicata; // Either application or extension data
  linkedApplicationData: RequestWithDuplicata = null;
  fromRoute: string;
  placeConsumed: Place;
  PlatformEventType = PlatformEventType;
  syncQueueSubscription: Subscription;
  searchParams = {};
  referencePaymentOnarrival: string; //TODO check if still needed
  printBorderPassData: PrintBorderpassData;
  printDecisionLetterData: PrintDecisionLetterData;
  eventCheckout: ConsumeRequestData;
  form: FormGroup;
  checkDraftTimeout: NodeJS.Timeout;
  finishCallPayment = false;
  seniorityLevel: null | number;
  currentPrintReceiptDatas: PrintReceiptData;
  isSyncing = false;
  cleanDate = cleanDate;
  isJsonParsable = isJsonParsable;
  canPrintSticker = canPrintSticker;
  isRequirePreapproval = isRequirePreapproval;
  canHaveDocuments = canHaveDocuments;
  printReceiptData: PrintReceiptData[] = [];
  OperationType = OperationType;
  ConsumePaymentNoticeType = NoticeType;
  selectedOperation = 0;
  printVisaApplication: DataGroup[] = [];
  checkRefusal: OperationType;
  RequestSubState = RequestSubState;
  status = RequestState;
  UserPermission = UserPermission;
  selectMode: boolean;
  selectedFields: VisaFN[] = [];
  printDocument: {
    title: string;
    img: string;
    id: string;
    date: string;
  } = {
      title: '',
      img: '',
      id: '',
      date: ''
    };
  approvalLetterData: PrintApprovalLetterData;
  referenceToPrint = '';
  showDocuments: { nameDocument: string, document: any }[] = [];
  visualizerIndex = '';
  metadataDocuments: { nameDocument: string, document: any, title?: string, icon?: string, customClass?: string, previewDirect?: string, checkComparison?: boolean}[] = [];
  isCatEasy = false;
  isPDF = isPDF;
  existingNotices: PlatformEvent[];
  formNotice: FormGroup;
  foundByScan = false;
  deportedMode = false;
  currentPlace: Place;
  createdPlace: Place;
  workerConsumeEntryExit = false;
  otherStateAction = false;
  offlineApplication: FormApplication;
  navigationListener: any;
  selectOptions: { name: string; value: number }[] = [];
  paymentSubscription: Subscription;
  routeParamSubscription: Subscription;
  routeQuerySubscription: Subscription;
  changeConsumeSubscription : Subscription;
  backupPingSubscription: Subscription;
  printSubscription: Subscription;
  navClickSubscription: Subscription;
  bookTimeslotDialogSubscription: Subscription;
  maritalStatusOptions : SelectOption[];
  genderOptions : SelectOption[];
  modeOfTravelOptions: SelectOption[];
  eyeColorOptions: SelectOption[];
  hairColorOptions: SelectOption[];
  statusOptions: SelectOption[];
  countryOptions: SelectOption[];
  diffDays: number;
  diffHours: number;
  differences: Difference[] = [];
  loadDocumentsClicked = false;
  selectedDocument: string | null = null;
  newNote = '';
  showAllNotes = false;
  displayedNotes: PlatformEvent[];
  travelHistory: {[id: string]: RequestWithDuplicata[]} = {};
  showMovements = false;
  showNotesCollapsed = true;
  editingDocName: string = null;
  showDocWebcam = false;
  missingSchemaDocuments: {name: string, title: string, icon: string}[] = [];
  @ViewChild('docFileInput') docFileInput: ElementRef<HTMLInputElement>;

  // transferFromPassportChecked removed in favor of reactive FormControl
  formTransfer = new FormGroup({transferFromPassport: new FormControl(false)});
  get transferFromPassportCtrl(): FormControl<boolean> {
    return this.formTransfer.get('transferFromPassport') as FormControl<boolean>;
  }
  get isTransferFromPassportChecked(): boolean {
    return !!this.transferFromPassportCtrl.value;
  }

  documentTypeIsVisa = documentTypeIsVisa;
  documentTypeIsExit = documentTypeIsExit;
  documentTypeIsEntry = documentTypeIsEntry;
  documentTypeIsProvisionalResidencePermit = documentTypeIsProvisionalResidencePermit;
  documentTypeIsVisaExtAB = documentTypeIsVisaExtAB;
  documentTypeIsVisaExtC = documentTypeIsVisaExtC;
  documentTypeIsVisaMultiple  = documentTypeIsVisaMultiple;
  documentTypeIsVisaDouble = documentTypeIsVisaDouble;
  documentTypeIsPassport = documentTypeIsPassport;
  documentTypeIsIdentityCard = documentTypeIsIdentityCard;
  documentTypeIsResidenceCard = documentTypeIsResidenceCard;
  documentTypeIsAnyVisa = documentTypeIsAnyVisa;
  documentTypeIsAnyExtension = documentTypeIsAnyExtension;
  hasUiPerm = hasUiPerm;

  constructor(public nav: NavigateService,
    public api: ApiService,
    public qr: QrService,
    public cart: CartService,
    public request: RequestService,
    public queue: QueueService,
    public scanDocument: ScanDocumentService,
    public sync: SyncService,
    public payment: PaymentService,
    private fingerprint: FingerprintService,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private formBuilder: FormBuilder,
    private dialogs: DialogsService,
    private dialog: DialogsService,
    private matDialog: MatDialog,
    private lang: LangService,
    private router: Router,
    private places: PlacesService,
    private print: PrintService,
    private storage: StorageService) {
    this.workerConsumeEntryExit = this.api.userRole.isWorker && this.api.hasPerm(UserPermission.ALLOW_CONSUME) && (this.scanDocument.consumeMode === ConsumeMode.ENTRY || this.scanDocument.consumeMode === ConsumeMode.EXIT || this.scanDocument.consumeMode === ConsumeMode.TRANSIT);
    this.places.getPlace(this.api.userPlaceId).then(place => {
      this.currentPlace = place;
    });
    this.seniorityLevel = this.api.checkSeniority();
    let registerScanSession = false;
    this.routeQuerySubscription =this.route.queryParams.subscribe(params => {

      const {from, registerSession, foundByScan, offlineApplication, ...search} = params;
      registerScanSession = registerSession;
      this.searchParams = search;
      this.fromRoute = from;
      this.foundByScan = foundByScan === 'true';

      if(offlineApplication) {
        this.offlineApplication = JSON.parse(offlineApplication);
        this.queue.onNavDeleteOfflineQueueId = this.offlineApplication.queueId;
        this.setOfflineCurrent(this.offlineApplication.requests[0] as RequestWithDuplicata, this.offlineApplication.queueId);
      } else {
        this.queue.onNavDeleteOfflineQueueId = undefined;
      }
    });

    this.routeParamSubscription = this.route.paramMap.subscribe(params => {
      this.paymentId = params.get('paymentId');
      if(this.scanDocument.scanDatas?.id && this.scanDocument.scanDatas.id !== this.paymentId) {
        this.scanDocument.resetScanDatas();
      }
      if(this.paymentId) window.sessionStorage.setItem('previousIdApplication', this.paymentId);

      if(registerScanSession && this.scanDocument.scanned) {
        this.scanDocument.scanDatas.id = this.paymentId;
        this.scanDocument.registerScanDatasToSession();
        this.scanDocument.scanned = false;
      }
      this.getPayment();
    });

    if(this.api.userRole.isWorker && this.api.hasPerm(UserPermission.ALLOW_CONSUME)) {
      this.syncQueueSubscription = this.cart.syncQueue$.subscribe((data) => {
        if(this.current?.id === data?.paymentId && data) {
          this.getPayment();
        }
      });
    }

    this.paymentSubscription = this.payment.current$.subscribe((payment) => {
      if(!payment || this.current && this.current.id !== payment.id) this.current = undefined;
      if(payment?.state === RequestState.PROPOSED) payment.allProcessed = false;

      this.current = payment;

      if(this.current?.internalReference && !this.travelHistory[this.current.internalReference]) {
        this.api.searchPayment({internalReference: this.current.internalReference}).then(res => {
          this.travelHistory[this.current.internalReference] = res?.result ?? [];
        });
      }

      const today = new Date();
      const localUsageUntil = new Date(this.current.localUsageUntil);
      this.diffDays = differenceInDays(today, localUsageUntil);
      this.diffHours = differenceInHours(today, localUsageUntil) % 24;
      this.updateDisplayedNotes();

      if(this.checkDraftTimeout) clearInterval(this.checkDraftTimeout);

      if(this.current) {
        if(!this.maritalStatusOptions ||!this.genderOptions || ! this.modeOfTravelOptions || this.eyeColorOptions || this.hairColorOptions || this.countryOptions) {
          this.api.schema(this.current?.document?.schema).then(schema => {
            const maritalStatusEnum = getEnumByRole(schema?.properties?.MaritalStatus, this.api.userInfo.role);
            const genderEnum = getEnumByRole(schema?.properties?.Gender, this.api.userInfo.role);
            const modeOfTravelEnum = getEnumByRole(schema?.properties?.ModeOfTravel, this.api.userInfo.role);
            const eyeColorEnum = getEnumByRole(schema?.properties?.EyeColor, this.api.userInfo.role);
            const hairColorEnum = getEnumByRole(schema?.properties?.HairColor, this.api.userInfo.role);
            const statusEnum = getEnumByRole(schema?.properties?.Status, this.api.userInfo.role);

            this.maritalStatusOptions = maritalStatusEnum.map((e: string) => ({value: e, name: this.lang.transform('marital.status.' + e.toLowerCase())}));
            this.genderOptions = genderEnum.filter((e: string) => e === e.toUpperCase()).map((e: string) => ({value: e, name: this.lang.transform('applicant.gender.' + e.toLowerCase())}));
            this.modeOfTravelOptions = modeOfTravelEnum.map((e: string) => ({value: e, name: this.lang.transform('DYN.' + e)}));
            this.eyeColorOptions = eyeColorEnum.map((e: string) => ({value: e, name: (this.lang.transform(e.toUpperCase()))}));
            this.hairColorOptions = hairColorEnum.map((e: string) => ({value: e, name: (this.lang.transform(e.toUpperCase()))}));
            this.statusOptions = statusEnum.map((e: string) => ({value: e, name: this.lang.transform('DYN.' + e)}));
            this.countryOptions = getCountries(false);
          });
          this.places.getPlace(this.current.created_place_id).then(place => {
            this.createdPlace = place;
          });
        }
        if(this.current.state !== RequestState.PROPOSED){
          this.loader.loading(false);
        }
        this.reloadOnDraft(this.current);
        this.paymentAdditional();
      } else {
        this.loader.loading(true);
      }
    });

    let ponged = false;
    this.backupPingSubscription = this.api.pingChange$.subscribe((pong) => {
      if(!ponged && pong === true && !this.current?.allProcessed) {
        ponged = true;
        this.getPayment();
      }
    });
    this.maritalStatusOptions = enumToArrayObjectSelect(MaritalStatus, '');
  }

  ngOnInit() {
    this.setForm();
  }

  ngOnDestroy() {
    if(this.routeParamSubscription) this.routeParamSubscription.unsubscribe();
    if(this.routeQuerySubscription) this.routeQuerySubscription.unsubscribe();
    if(this.paymentSubscription) this.paymentSubscription.unsubscribe();
    if(this.checkDraftTimeout) clearInterval(this.checkDraftTimeout);
    if(this.syncQueueSubscription) this.syncQueueSubscription.unsubscribe();
    if(this.backupPingSubscription) this.backupPingSubscription.unsubscribe();
    if(this.changeConsumeSubscription) this.changeConsumeSubscription.unsubscribe();
    if(this.printSubscription) this.printSubscription.unsubscribe();
    if(this.navClickSubscription) this.navClickSubscription.unsubscribe();
    if(this.bookTimeslotDialogSubscription) this.bookTimeslotDialogSubscription.unsubscribe();
  }

  pay() {
    const message = this.lang.transform('totalAmount') + ': ' + this.getAmount(this.current.currency as any, this.current.amountCents);
    if(this.current.state === RequestState.DELAY_PAY && this.current.metadata?.RegistrationPortId === this.api.userPlaceId) {
      this.loader.loading(true, {
        type: 'info',
        btnLabel: 'global.pay',
        message
      }).then((confirmed: boolean) => {
        if(confirmed) {
          this.api.changePayment(this.current.id, RequestState.PAID, RequestSubState.NONE).then(() => {
            this.storage.removeFromStorage(Store.PAYMENT_STORE, this.current.id).then(() => {
              setTimeout(() => this.getPayment());
            });
            this.loader.loading(true, {type: 'valid',  message: 'payment.success'});
          }).catch(() => {
            this.loader.loading(true, {type: 'error', message: 'payment.error'});
          });
        }
      });
    }
  }

  getTotalDaysExtension(): number {
    if(!this.current?.events) return 0;
    return this.current.events.filter(event => event.type === PlatformEventType.PAYMENT_EXTENDED).map(event => {
      try {
        const ctx = typeof event.context === 'string' ? JSON.parse(event.context) : event.context;
        return Number(ctx.daysGranted) || 0;
      } catch {
        return 0;
      }
    }).reduce((sum, days) => sum + days, 0);
  }

  getSubtractedDate(): Date | null {
    const totalDays = this.getTotalDaysExtension();
    if(!this.current?.localUsageUntil || typeof totalDays !== 'number') return null;
    const baseDate = new Date(this.current.localUsageUntil);
    const subtractedDate = addDays(baseDate, -totalDays);

    if(subtractedDate.getTime() === baseDate.getTime()) {
      return null;
    }
    return subtractedDate;
  }

  updateField(field: VisaFN, inputType: DialogFormInput['type'], value: any, selectedValues?: any[], subField?: string, extraPerm?: UiPermission) {
    if(!this.canUpdateField() && !this.canUpdateFieldAsBorder() && !(extraPerm && this.hasUiPerm(extraPerm))) return;
    this.api.schema(this.current?.document?.schema).then(schema => {
      const def = subField ? schema?.properties?.[field]?.[subField] : schema?.properties?.[field] || schema?.[field];
      const validators: ValidatorFn[] = [];

      if(field === VisaFN.NEXT_OF_KIN && subField) {
        switch(subField) {
        case 'firstname':
        case 'lastname':
          validators.push(Validators.maxLength(50), Validators.pattern('^[A-Za-z\\s\\-]+$'));
          break;
        case 'email':
          validators.push(Validators.email, Validators.maxLength(100));
          break;
        case 'phone':
          validators.push(Validators.pattern('^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,9}$'), Validators.maxLength(20));
          break;
        }
      }

      const validatorMap: Record<string, (val: any, def: any) => ValidatorFn | null> = {
        maxLength: (val) => Validators.maxLength(val),
        minLength: (val) => Validators.minLength(val),
        minimum: (val) => Validators.min(val),
        maximum: (val) => Validators.max(val),
        frontPattern: (val) => Validators.pattern(new RegExp(val, 'u')),
        pattern: (val) => {
          if(!val) return null;
          if(val.includes('\\p{')) {
            const unicodePatternValidator = (control: AbstractControl) => {
              if(!control.value) return null;
              try {
                const regex = new RegExp(val, 'u');
                return regex.test(control.value)
                  ? null
                  : {pattern: {value: control.value, requiredPattern: val}};
              } catch {
                console.warn(`Invalid Unicode regex pattern: ${val}`);
                return null;
              }
            };
            return unicodePatternValidator;
          } else {
            return Validators.pattern(val);
          }
        }
      };

      Object.entries(def || {}).forEach(([key, val]) => {
        const builder = validatorMap[key];
        if(builder) {
          const v = builder(val, def);
          if(v) validators.push(v);
        }
      });

      if(inputType === 'email'){
        validators.push(Validators.email);
      }

      validators.push(Validators.required);

      if(['date', 'datetime-local'].includes(inputType)) {
        if(def?.maxDateMilliFromNow !== undefined || def?.minDateMilliFromNow !== undefined) {
          validators.push(dateMilliFromNowValidator({
            maxDateMilliFromNow: def.maxDateMilliFromNow,
            minDateMilliFromNow: def.minDateMilliFromNow
          }));
        }
      }

      const dialogInput: DialogFormInput[] = [{
        formCtrlName: field,
        type: inputType,
        label: field,
        selectOptions: selectedValues,
        maxLength: def?.maxLength,
        pattern: def?.frontPattern || def?.pattern,
        value: inputType === 'date' && value ? format(new Date(value), 'yyyy-MM-dd') : value,
        validator: validators
      }];

      this.loader.loading(true, {type: 'info', btnLabel: 'global.update', custom: {icon: 'pen-to-square', innerHtml: this.lang.transform('updateField.desc', {field: this.lang.transform(field)})}, dialogInput
      }).then((res: any) => {
        if(!(res?.[field] && res?.[field] !== value)) return;

        let newValue = res[field];

        if(typeof newValue === 'string') {
          switch(def?.transformation) {
          case 'uppercase': newValue = newValue.toUpperCase(); break;
          case 'lowercase': newValue = newValue.toLowerCase(); break;
          case 'trim': newValue = newValue.trim(); break;
          }
        }

        if(inputType === 'date' || inputType === 'datetime-local') {
          newValue = new Date(newValue);
        }

        const buildMetadataUpdate = (): Record<string, any> => {
          switch(field) {
          case VisaFN.NEXT_OF_KIN: {
            const existingNextOfKin = JSON.parse(this.current?.metadata?.NextOfKin || '{}');
            const mergedNextOfKin = {...existingNextOfKin, [subField!]: newValue};
            return {NextOfKin: JSON.stringify(mergedNextOfKin)};
          }
          case VisaFN.INVITING_COMPANY_NAME: {
            return {Documents: {InvitingCompanyName: newValue}};
          }
          case VisaFN.MODE_OF_TRAVEL: {
            const target = TRAVEL_NUM_BY_MODE[newValue];
            const oldTarget = TRAVEL_NUM_BY_MODE[value];
            return {[field]: newValue, ...(target && oldTarget ? {[target]: this.current?.metadata?.[oldTarget] ?? 'N/A'} : {}), ...(oldTarget ? {[oldTarget]: ''} : {})};
          }
          default:
            return {[field]: newValue};
          }
        };

        const metadataUpdate = buildMetadataUpdate();
        const serializedDatas = JSON.stringify(metadataUpdate);

        this.api.updatePayment(this.current.id, undefined, undefined, ![VisaFN.USAGE_AFTER, VisaFN.USAGE_UNTIL].includes(field) ? serializedDatas : undefined, undefined, undefined, undefined, undefined, field === VisaFN.USAGE_AFTER ? newValue : undefined, field === VisaFN.USAGE_UNTIL ? newValue : undefined).then(() => {
          this.current = {...this.current, metadata: {...this.current.metadata, ...metadataUpdate}};
        }).catch((err) => {
          this.loader.loading(true, {type: 'error', message: err});
        });
      });
    });
  }

  canUpdateField(): boolean {
    return this.hasUiPerm.call(this, UiPermission.CAN_UPDATE_FIELDS) && this.current.state !== RequestState.USED;
  }

  canUpdateFieldAsBorder(): boolean {
    return this.hasUiPerm.call(this, UiPermission.CAN_UPDATE_FIELD_AS_BORDER) && this.current.usageCount < 1;
  }

  canUpdateDoc(): boolean {
    return this.hasUiPerm.call(this, UiPermission.CAN_UPDATE_DOC);
  }

  getDocumentSchemaFields(): FormField[] {
    const formConfigs = loadFormConfigs();
    const configKey = getFormConfig(this.current.operationId as DocumentType, this.current, this.api);
    const formConfig: VisaFormConfig = (formConfigs as any)?.[configKey];
    if(!formConfig) return [];
    const docStep = formConfig[VisaFormName.DOCUMENT];
    return docStep?.fields || [];
  }

  isDocScanType(docName: string): boolean {
    const field = this.getDocumentSchemaFields().find(f => f.name === docName);
    return field?.type === 'scanDoc';
  }

  getDocTitleAndIcon(docName: string): {title: string, icon: string} {
    switch(docName) {
    case VisaFN.PASSPORT_PHOTO: return {title: 'photo.current', icon: 'camera'};
    case VisaFN.PASSPORT_SCAN: return {title: 'data.biographic', icon: 'passport'};
    case VisaFN.PROOF_OF_RESIDENCE: return {title: 'residence.proof', icon: 'house'};
    case VisaFN.COPY_OF_ENTRY: return {title: 'data.copyOfEntry', icon: 'passport'};
    case VisaFN.DEPARTURE_TICKET: return {title: 'data.departureTicket', icon: 'passport'};
    case VisaFN.ATTESTANT_DOCUMENT: return {title: 'data.attestantDocument', icon: 'passport'};
    case VisaFN.AFFIDAVIT_CUSTODY: return {title: 'data.affidavitCustody', icon: 'passport'};
    case VisaFN.REASON_OF_VISIT_PROOF: return {title: 'reasonOfVisit.proof', icon: 'file-lines'};
    case VisaFN.ADDRESS_AT_DESTINATION: return {title: 'address.destination', icon: 'location-dot'};
    case VisaFN.PREVIOUS_ZIMBABWEAN_VISA: return {title: 'previous.visa', icon: 'file-lines'};
    case VisaFN.INVITATION_LETTER_AND_BUSINESS_PROFILE: return {title: 'inviteBusiness.letter', icon: 'envelope-open-text'};
    case VisaFN.BUSINESS_PROFILE: return {title: 'business.profile', icon: 'user'};
    case VisaFN.APPLICATION_LETTER: return {title: 'application.letter', icon: 'envelope-open-text'};
    case VisaFN.LETTER_OF_ACCEPTANCE_FROM_SCHOOL: return {title: 'acceptanceFromScool.letter', icon: 'envelope-open-text'};
    case VisaFN.BUSINESS_LETTER: return {title: 'BusinessLetter', icon: 'envelope-open-text'};
    case VisaFN.HOST_INVITATION_LETTER: return {title: 'hostInvitation.letter', icon: 'envelope-open-text'};
    case VisaFN.PROOF_OF_RESIDENCE_HOST: return {title: 'proof.residenceHost', icon: 'home'};
    case VisaFN.RESIDENTIAL_STATUS_OF_HOST: return {title: 'hostResidential.status', icon: 'id-card'};
    case VisaFN.INVITATION_LETTER: return {title: 'invite.letter', icon: 'envelope-open-text'};
    case VisaFN.EXTRA_DOCUMENT_1: return {title: 'ExtraDocument1', icon: 'file-image'};
    case VisaFN.EXTRA_DOCUMENT_2: return {title: 'ExtraDocument2', icon: 'file-image'};
    case VisaFN.EXTRA_DOCUMENT_3: return {title: 'ExtraDocument3', icon: 'file-image'};
    case VisaFN.EXTRA_DOCUMENT_4: return {title: 'ExtraDocument4', icon: 'file-image'};
    case VisaFN.EXTRA_DOCUMENT_5: return {title: 'ExtraDocument5', icon: 'file-image'};
    case VisaFN.PREVIOUS_VISA: return {title: 'PreviousVisa', icon: 'file-image'};
    case VisaFN.NO_FEE_PROOF: return {title: 'NoFeeProof', icon: 'file-invoice'};
    case VisaFN.PHOTO: return {title: 'Photo', icon: 'user'};
    case VisaFN.RENEWDOCUMENTFILE: return {title: 'RenewDocumentFile', icon: 'home'};
    case VisaFN.APPLICATION_FORM: return {title: 'ApplicationForm', icon: 'file-lines'};
    case VisaFN.BIRTH_CERTIFICATE: return {title: 'BirthCertificate', icon: 'file-lines'};
    case VisaFN.RESIDENCE_CERTIFICATE: return {title: 'ResidenceCertificate', icon: 'file-lines'};
    case VisaFN.NATIONALITY_CERTIFICATE: return {title: 'NationalityCertificate', icon: 'file-lines'};
    case VisaFN.PARENTAL_AUTHORIZATION: return {title: 'ParentalAuthorization', icon: 'file-lines'};
    case VisaFN.CS_IDENTIFIER: return {title: 'CSIdentifier', icon: 'file-lines'};
    case VisaFN.IDENTITY_PHOTO: return {title: 'IdentityPhoto', icon: 'file-lines'};
    case VisaFN.FORM_DEMAND: return {title: 'FormDemand', icon: 'file-lines'};
    case VisaFN.WORK_CONTRACT: return {title: 'WorkContract', icon: 'file-lines'};
    case VisaFN.EMPLOYER_COMMITMENT_FORM: return {title: 'EmployerCommitmentForm', icon: 'file-lines'};
    case VisaFN.IDENTIFICATION_SHEET: return {title: 'IdentificationSheet', icon: 'file-lines'};
    case VisaFN.AUTHORIZATION_FORM: return {title: 'AuthorizationForm', icon: 'file-lines'};
    case VisaFN.APPROVED_MISSION_ORDER: return {title: 'ApprovedMissionOrder', icon: 'file-lines'};
    case VisaFN.LOSS_DECLARATION: return {title: 'LossDeclaration', icon: 'file-lines'};
    case VisaFN.ID_CARD_SCAN: return {title: 'IdCardScan', icon: 'file-lines'};
    default: return {title: docName, icon: 'file'};
    }
  }

  getMissingSchemaDocuments(): {name: string, title: string, icon: string}[] {
    const schemaFields = this.getDocumentSchemaFields();
    if(!schemaFields.length) return [];
    const existingDocNames = new Set(this.current?.metadata?.Documents
      ? Object.keys(this.current.metadata.Documents).filter(k => {
        const val = this.current.metadata.Documents[k];
        return isBase64(val) || isPDF(val);
      })
      : []);
    return schemaFields
      .filter(f => (f.type === 'file' || f.type === 'scanDoc') && !existingDocNames.has(f.name))
      .map(f => {
        const {title, icon} = this.getDocTitleAndIcon(f.name);
        return {name: f.name, title, icon};
      });
  }

  updateDocument(docName: string) {
    if(!this.canUpdateDoc()) return;
    const useScan = this.isDocScanType(docName) && this.api.userRole.isWorker;
    if(useScan) {
      this.editingDocName = docName;
      this.showDocWebcam = true;
    } else {
      this.editingDocName = docName;
      setTimeout(() => this.docFileInput?.nativeElement?.click());
    }
  }

  onDocWebcamCapture(base64: string) {
    this.showDocWebcam = false;
    if(base64 && this.editingDocName) {
      this.saveDocumentUpdate(this.editingDocName, base64);
    }
    this.editingDocName = null;
  }

  onDocFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if(!file || !this.editingDocName) {
      this.editingDocName = null;
      return;
    }
    const docName = this.editingDocName;
    if(file.type === 'application/pdf') {
      if((file.size / 1024 / 1024) <= 1) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.saveDocumentUpdate(docName, e.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        this.loader.loading(true, {type: 'error', message: this.lang.transform('err.file.size') + ' 1MB'});
      }
    } else {
      this.loader.loading(true);
      compressFile(file, 0.5).then((b64: string) => {
        this.loader.loading(false);
        this.saveDocumentUpdate(docName, b64);
      }).catch((err: any) => {
        this.loader.loading(true, {type: 'error', message: err});
      });
    }
    input.value = '';
    this.editingDocName = null;
  }

  deleteDocument(docName: string): void {
    this.saveDocumentUpdate(docName, null);
  }

  saveDocumentUpdate(docName: string, base64: string | null) {
    this.loader.loading(true);
    const serialized = JSON.stringify({Documents: {[docName]: base64}});
    this.api.updatePayment(this.current.id, undefined, undefined, serialized, undefined, undefined, undefined, undefined).then(() => {
      if(!this.current.metadata.Documents) this.current.metadata.Documents = {};
      if(base64) {
        this.current.metadata.Documents[docName] = base64;
      } else {
        delete this.current.metadata.Documents[docName];
      }
      this.prepareVisualDocuments();
      this.storage.removeFromStorage(Store.PAYMENT_STORE, this.current.id).then(() => {
        setTimeout(() => this.getPayment());
      });
      this.loader.loading(false);
    }).catch((err) => {
      this.loader.loading(true, {type: 'error', message: err});
    });
  }

  openBookTimeslotDialog(): void {
    const dialogRef = this.matDialog.open(DialogBookTimeSlotComponent, {
      width: '900px',
      data: {
        payment: this.current,
        placeId: this.api.userPlaceId,
        paymentRequest: this.current.document,
        usageUntil: this.current.localUsageUntil
      }
    });

    if(this.bookTimeslotDialogSubscription) {
      this.bookTimeslotDialogSubscription.unsubscribe();
    }

    this.bookTimeslotDialogSubscription = dialogRef.afterClosed().subscribe((result: any) => {
      if(result) {
        this.getPayment();
      }
    });
  }

  isTimeslotExpired(): boolean {
    return this.current?.timeslot && isBefore(this.current.timeslot, new Date());
  }

  isBookTimeslotPortAllowed(): boolean {
    if(!this.api.userInfo.server.allowedBookTimeslotPortIds) {
      return true;
    }
    const registrationPortId = this.current?.metadata?.RegistrationPortId;
    if(!registrationPortId) {
      return false;
    }
    return this.api.userInfo.server.allowedBookTimeslotPortIds.includes(registrationPortId);
  }

  checkIfSpecifiedNationals(checkoutIsNextOrForce?: boolean ): boolean {
    const currentPlace = this.api.userPlace;
    const checkoutNormalFlow = checkoutIsNextOrForce && !documentTypeIsExit(this.current.operationId);
    return currentPlace && currentPlace.specifiedNationals.includes(this.scanDocument.scanDatas?.fields?.nationality || this.current.metadata?.Nationality) && !checkoutNormalFlow;
  }

  paymentAdditional() {
    this.isSyncing = this.cart.syncQueue.some(item => item.paymentId === this.paymentId) || this.queue.requestInQueue(this.paymentId);
    this.isCatEasy = isCanHaveOnArrival(this.current);
    this.detectConsumeMode();
    this.changeConsumeSubscription = this.scanDocument.consumeMode$.subscribe(() => {
      this.detectConsumeMode();
    });
    if(this.scanDocument.scanned && this.scanDocument.scanDatas && this.current.metadata?.PassportNumber && this.current.metadata?.Nationality) {
      const {nationality, issuingState} = this.scanDocument.scanDatas.fields || {};
      this.current.canBeDeported = this.scanDocument.isZweRefugee(nationality, issuingState);
      this.current.showComparison = this.scanDocument.scanDatas.fields?.documentNumber === this.current.metadata?.PassportNumber && this.scanDocument.scanDatas.fields?.nationality === this.current.metadata?.Nationality;
    } else {
      this.current.showComparison = this.api.hasPerm(UserPermission.ALLOW_CONSUME) || this.api.hasPerm(UserPermission.ALLOW_ADMIN);
    }

    // Initialize checkbox default state
    this.differences = this.hasDifferences();
    this.transferFromPassportCtrl.setValue(this.differences.length > 0, {emitEvent: false});

    this.printVisaApplication = [];
    this.preparePrintVisa();

    if(this.current.allProcessed) {
      this.qr.setCurrentQrData(undefined, this.current);
      this.preparePrintPersonalData();
      this.prepareContactDataPrint();
      this.preparePrintDiversVisa();
      this.preparePrintNextOfKin();
      this.preparePrintExtension();
      this.preparePrintSpouse();
      this.preparePrintReceipt();
      this.preparePrintBorderPass();
      this.preparePrintNotices();
      this.prepareVisualDocuments();

      const checkWarningMessages = () => {
        const warningMessage = this.getWarningMessage();
        if(warningMessage) {
          this.loader.loading(true, {type: 'warn', hideCloseBtn: true, btnLabel: 'payAttention', custom: {innerHtml: warningMessage}}).then(() => {
            this.checkScannedGender();
          });
        } else if(this.current.isBlacklisted) {
          this.loader.loading(true, {type: 'warn', message: 'visa.blacklist'}).then(() => {
            this.checkScannedGender();
          });
        } else if(this.isRequirePreapproval(this.current, this.api.env)) {
          this.loader.loading(true, {type: 'warn', custom: {innerHtml: this.lang.transform('visa.catC.ordinary')}}).then(() => {
            this.checkScannedGender();
          });
        } else {
          this.checkScannedGender();
        }
      };

      checkWarningMessages();
      const docs = this.current.metadata?.Documents;
      const checkDocs = docs ? Object.keys(docs).filter(key => key !== VisaFN.PURPOSE_OF_VISIT) : [];

      if(this.loadDocumentsClicked && checkDocs.length === 0) {
        this.loader.loading(true, {type: 'info', message: 'documents.no.documents'});
      }
    }
  }

  rejectOrValidatePayment(refuse: boolean) {
    const dialogReasonInput = [{
      formCtrlName: 'reason',
      type: 'textarea',
      label: 'payment.reject_reason',
      maxLength: 200,
      validator: refuse ? [Validators.required] : []
    }] as DialogFormInput[];

    if(refuse) {
      this.loader.loading(true, {type: 'warn', message: 'payment.reject_desc', dialogInput: dialogReasonInput}).then((res: any) => {
        if(res?.reason) {
          this.loader.loading(true);
          this.api.validatePayment(this.current.id, this.api.userPlaceId, refuse, res.reason).then(() => {
            if(this.fromRoute) {
              this.nav.to(this.fromRoute);
            } else {
              this.nav.to('admin-request');
            }
          }).catch((err) => {
            this.loader.loading(true, {type: 'error', message: err});
          });
        }
      });
    } else {
      this.loader.loading(true, {type: 'info', message: 'payment.validate_desc', btnLabel: 'global.confirm'}).then((done) => {
        if(done) {
          this.loader.loading(true);
          this.api.validatePayment(this.current.id, this.api.userPlaceId, refuse, '').then(() => {
            if(this.fromRoute) {
              this.nav.to(this.fromRoute);
            } else {
              this.nav.to('admin-request');
            }
          }).catch((err) => {
            this.loader.loading(true, {type: 'error', message: err});
          });
        }
      });
    }
  }

  checkIn(refuse = false, useFingerprint = false, useNoticePrint = false, supervisor?: string, passSupervision = false, skipCamera = false, skipCameraDialogDone = false, deportedComment?: string, forceOperation?: OperationType) {
    if(this.request.isPermitNumberCheckRequired(this.current)) {
      this.loader.loading(true, {
        type: 'warn',
        btnLabel: this.lang.transform('global.confirm'),
        custom: {closeBtnLabel: this.lang.transform('global.reject'), innerHtml: this.lang.transform('residencePermit.warning', {permitNumber: this.current.metadata.ResidencePermitNumber})}
      }).then((confirmed: boolean) => {
        this.consumePayment(!confirmed, useFingerprint, useNoticePrint, supervisor, passSupervision, skipCamera, skipCameraDialogDone, deportedComment, forceOperation);
      });
      return;
    } else {
      this.consumePayment(refuse, useFingerprint, useNoticePrint, supervisor, passSupervision, skipCamera, skipCameraDialogDone, deportedComment, forceOperation);
    }
  }

  consumePayment(refuse = false, useFingerprint = false, useNoticePrint = false, supervisor?: string, passSupervision = false, skipCamera = false, skipCameraDialogDone = false, deportedComment?: string, forceOperation?: OperationType) {
    const updateScannedPassport = () => {
      //TODO: maybe put in queue to garantee correct information sent to central
      const overrides: Partial<FieldRecords> = {};
      this.differences.forEach(diff => {
        overrides[diff.key] = diff.scanNorm;
      });
      this.scanDocument.transferFromPassportData(this.current.id, overrides).catch(err => console.error('Error transferring data from passport', err));
      //reset the checkbox after the update is done and call the consumePayment again
      this.transferFromPassportCtrl.setValue(false, {emitEvent: false});
      this.consumePayment(refuse, useFingerprint, useNoticePrint, supervisor, passSupervision, skipCamera, skipCameraDialogDone, deportedComment, forceOperation);
    };

    // If transferFromPassport is checked, update scanned passport before consuming
    if(this.transferFromPassportCtrl.value) {
      updateScannedPassport();
      return;
    }

    const operation = forceOperation ? forceOperation : ((this.deportedMode && !refuse) ? OperationType.INRETURNED : (this.current.checkoutIsNext || documentTypeIsExit(this.current.operationId)) ? refuse ? OperationType.REFUSEOUT : OperationType.OUT : refuse ? OperationType.REFUSEIN : OperationType.IN);
    if(operation.indexOf('IN') > -1) {
      //Check if place can consume or show places that can;
      const places = this.places.getPlacesThatCanConsume(this.current.document?.id as DocumentType, 'id');
      if(places.length && places.indexOf(this.api.userPlaceId) === -1) {
        this.loader.loading(true, {type: 'error', custom: {innerHtml: this.lang.transform('payment.consume.placeNotAllowed', {places: places.join(', ')}), icon: 'location-pin-lock'}});
        return;
      }
    }

    const checkoutIsNextOrForce = this.current.checkoutIsNext || forceOperation === OperationType.OUT;
    if(skipCamera && !skipCameraDialogDone && !refuse) {
      const dialogInput = this.deportedMode ? [{
        formCtrlName: 'deportedComment',
        type: 'textarea',
        label: 'deportedComment',
        maxLength: 1000
      }] as DialogFormInput[] : [];
      this.loader.loading(true, {type: 'info', message: 'payment.consume.ask.DYN.', btnLabel: 'global.confirm', dialogInput}).then((done: any) => {
        if(done) {
          this.consumePayment(refuse, useFingerprint, useNoticePrint, supervisor, passSupervision, skipCamera, true, done?.deportedComment);
        }
      });
      return;
    }

    if(!passSupervision && ((this.current.metadata.PassportType === PassportType.REFUGEE && documentTypeIsEntry(this.current.operationId) && !this.api.env.nationalityNoDeclaration.includes(this.current.metadata.PassportCountry))
      || (this.isRequirePreapproval(this.current, this.api.env) || this.current.isBlacklisted || (this.checkIfSpecifiedNationals(checkoutIsNextOrForce) && (this.scanDocument.consumeMode !== 'exit') && (this.current.metadata.PassportType === PassportType.ORDINARY))))) {
      let supervisionAction = '';
      if(this.current.isBlacklisted) supervisionAction = 'supervision.blacklist';
      if(this.checkIfSpecifiedNationals(checkoutIsNextOrForce)) supervisionAction = 'supervision.specifiedNationals';
      if(this.isRequirePreapproval(this.current, this.api.env) && !refuse) supervisionAction = 'supervision.catC.ordinary.entry';
      if(this.isRequirePreapproval(this.current, this.api.env) && refuse) supervisionAction = 'supervision.catC.ordinary.refuse';
      this.fingerprint.supervision(supervisionAction).then((supervisorAccountName: string) => {
        this.consumePayment(refuse, useFingerprint, useNoticePrint, supervisorAccountName, true);
      });
      return;
    }

    const cleanupSession = () => {
      window.sessionStorage.removeItem('noticePrint');
      window.sessionStorage.removeItem('fingerprint');
    };
    const consumeAction = (fingerprint = false) => {
      const navToFaceCheck = (paymentReference? : string, cashType?: RequestCashType, currency?: string, localUsageUntil?: Date, supervisorAccountName?: string, printOverstayReceipt?: boolean) => {
        cleanupSession();
        const operationId = this.scanDocument.consumeMode === ConsumeMode.TRANSIT ? 'Transit' : this.current.operationId;
        this.nav.to(fingerprint ? 'admin-scan-fingerprint' : 'admin-request-face-check', undefined, {queryParams: {
          from: this.fromRoute,
          paymentId: this.current.id,
          userPlaceID: this.api.userPlaceId,
          amount: (checkoutIsNextOrForce && this.isLocalUsageUntilError()) ? this.api.userInfo.server.paymentNonDocumentsCents.overstay : this.current.amountCents,
          nameClient: (this.scanDocument?.scanDatas?.fields?.firstName || this.current.metadata.FirstName || '') + ' ' + (this.scanDocument?.scanDatas?.fields?.lastName || this.current.metadata.LastName || ''),
          placeID: this.current.created_place_id,
          buyDocument: operationId,
          createdAt: this.current.createdAt,
          occupationMedia: this.current.metadata?.Occupation?.toLowerCase()?.includes('media'),
          provisionalPermit: documentTypeIsProvisionalResidencePermit(this.current.operationId),
          fromNoticePrint: false,
          borderPass: this.current.metadata.BorderPass ? this.current.metadata.BorderPass : undefined,
          fromScanFingerprint: fingerprint,
          operation: operation,
          paymentReference: paymentReference || this.current.externalId,
          paymentIsNotDocument: (checkoutIsNextOrForce && this.isLocalUsageUntilError()) ? 'Yes' : 'No',
          cashType,
          currency: currency || this.current.currency,
          localUsageUntil: localUsageUntil ? localUsageUntil.toString() : hasValue(this.current.localUsageUntil, 'date') ? new Date(this.current.localUsageUntil!).getTime() : undefined,
          purposeOfVisit: (this.current.metadata.Documents && this.current.metadata.Documents.PurposeOfVisit) ? this.current.metadata.Documents.PurposeOfVisit : undefined,
          skipCamera: skipCamera,
          refuseFingerPrint: useFingerprint && refuse,
          nationality: this.current.metadata.Nationality,
          gender: this.current.metadata.Gender,
          HQReference: this.current.internalReference,
          vendorName: this.api.userInfo.server.emailConfig.copyrightName,
          vendorAddress: this.api.userInfo.server.emailConfig.address,
          vendorEmail: this.api.userInfo.server.emailConfig.email,
          foundByScan: this.foundByScan,
          forceOperation: forceOperation,
          deportedComment: this.deportedMode ? (deportedComment ? deportedComment : skipCamera ? '' : undefined) : undefined,
          offlineApplication: this.offlineApplication ? JSON.stringify(this.current) : undefined,
          supervisor: supervisorAccountName || supervisor,
          printOverstayReceipt: printOverstayReceipt,
          ...this.searchParams
        }});
      };
      const navToNoticePrint = (paymentReference?: string, cashType?: RequestCashType, currency?: string, notice?: NoticeType, localUsageUntil?: Date, printOverstayReceipt?: boolean) => {
        cleanupSession();
        this.nav.to('admin-request-notice/' + this.current.id, undefined, {queryParams: {
          from: 'admin-request-select/' + this.current.id,
          fromRoute: this.fromRoute,
          paymentId: this.current.id,
          userPlaceID: this.api.userPlaceId,
          placeID: this.current.created_place_id,
          buyDocument: this.current.operationId,
          createdAt: this.current.createdAt,
          notice: notice,
          amount: (checkoutIsNextOrForce && this.isLocalUsageUntilError()) ? this.api.userInfo.server.paymentNonDocumentsCents.overstay : this.current.amountCents,
          nameClient: (this.current.metadata.FirstName || '') + ' ' + (this.current.metadata?.LastName || ''),
          fromScanFingerprint: fingerprint,
          fromNoticePrint: true,
          borderPass: this.current.metadata.BorderPass ? this.current.metadata.BorderPass : undefined,
          operation: operation,
          paymentReference,
          paymentIsNotDocument: (checkoutIsNextOrForce && this.isLocalUsageUntilError()) ? 'Yes' : 'No',
          cashType,
          currency,
          localUsageUntil: localUsageUntil ? localUsageUntil.toString() : hasValue(this.current.localUsageUntil, 'date') ? new Date(this.current.localUsageUntil!).getTime() : undefined,
          skipCamera: skipCamera,
          purposeOfVisit: (this.current.metadata.Documents && this.current.metadata.Documents.PurposeOfVisit) ? this.current.metadata.Documents.PurposeOfVisit : undefined,
          nationality: this.current.metadata.Nationality,
          gender: this.current.metadata.Gender,
          HQReference: this.current.internalReference,
          vendorName: this.api.userInfo.server.emailConfig.copyrightName,
          vendorAddress: this.api.userInfo.server.emailConfig.address,
          vendorEmail: this.api.userInfo.server.emailConfig.email,
          forceOperation: forceOperation,
          foundByScan: this.foundByScan,
          offlineApplication: this.offlineApplication ? JSON.stringify(this.current) : undefined,
          supervisor: supervisor,
          printOverstayReceipt: printOverstayReceipt,
          ...this.searchParams
        }});
      };

      const expirationDate = this.scanDocument.scanDatas?.fields?.expirationDate ? parse(this.scanDocument.scanDatas.fields.expirationDate, 'yyMMdd', startOfDay(new Date())) : null;
      const defaultDate = expirationDate && isBefore(expirationDate, addMilliseconds(startOfDay(new Date()), +this.current.defaultLocalUsageUntilFromServer)) ? expirationDate : addMilliseconds(startOfDay(new Date()), +this.current.defaultLocalUsageUntilFromServer);
      const maxDate = expirationDate && isBefore(expirationDate, addMilliseconds(startOfDay(new Date()), this.current.localUsageUntilFromServer)) ? expirationDate : addMilliseconds(startOfDay(new Date()), this.current.localUsageUntilFromServer);
      const defaultDays = differenceInDays(defaultDate, startOfDay(new Date()));
      const maxDays = differenceInDays(maxDate, startOfDay(new Date()));
      const generateDynamicLabel = (days?: number): string => {
        if(!days || days < 1 || days > maxDays) {
          return this.lang.transform('localUsageUntil.ask.invalid');
        }
        const recalculatedDate = addDays(new Date(), days);
        return this.lang.transform('localUsageUntil.ask', {
          calculatedDate: format(recalculatedDate, 'dd/MM/yyyy')
        });
      };
      const consume = (skipPayment = false) => {
        if(refuse) {
          this.loader.loading(true, {type: 'warn', message: 'checkinOut.refuse', btnLabel: 'global.confirm'}).then((done) =>{
            if(done) {
              if(useFingerprint) {
                navToFaceCheck();
              } else if(((this.request.getStatusTheme(this.current).actionState === ActionState.READY_CHECKIN ||
              this.request.getStatusTheme(this.current).actionState === ActionState.READY_CHECK)) && !documentTypeIsExit(this.current.operationId)) {
                navToNoticePrint(undefined, undefined, undefined, NoticeType.REFUSAL);
              } else {
                navToFaceCheck();
              }
            }
          });
        } else {
          if(this.current.state === RequestState.DELAY_PAY) {
            if(documentTypeIsProvisionalResidencePermit(this.current.operationId)) {
              navToNoticePrint(undefined, undefined, undefined, NoticeType.RESTRICTION);
            } else {
              const currencyInput = {
                formCtrlName: 'currency',
                type: 'select',
                label: 'form.currency',
                selectOptions: this.api.env.supportedCurrencies as any[],
                validator: [Validators.required]
              } as DialogFormInput;
              const dialogInput = [
                {
                  formCtrlName: 'paymentReference',
                  type: 'text',
                  label: 'paymentReference.ask',
                  maxLength: 60,
                  validator: [Validators.required],
                  value: uuid.v1()
                },
                currencyInput
              ] as DialogFormInput[];
              if(!documentTypeIsExit(this.current.operationId)) {
                const cashTypeInput = {
                  formCtrlName: 'cashType',
                  type: 'select',
                  label: 'method.payment',
                  validator: [Validators.required],
                  selectOptions: [
                    {name: 'form.type.CASH', value: RequestCashType.CASH},
                    {name: 'form.type.CARD', value: RequestCashType.CARD}
                  ],
                  onChangeAction: (newValue: RequestCashType) => {
                    const list: any = newValue === RequestCashType.CARD ? (this.api.env.supportedCardCurrencies || []) : (this.api.env.supportedCurrencies || []);
                    currencyInput.selectOptions = list;
                  }
                };
                const localUsageUntilInput = {
                  formCtrlName: 'localUsageUntil',
                  type: 'text',
                  label: generateDynamicLabel(defaultDays),
                  value: String(defaultDays),
                  validator: [Validators.min(1), Validators.max(maxDays), Validators.required, Validators.pattern('^[0-9]*$')],
                  onChangeAction: (newValue: string) => {
                    const days = Number(newValue);
                    localUsageUntilInput.label = generateDynamicLabel(days);
                  }
                };
                dialogInput.push(cashTypeInput as DialogFormInput);
                dialogInput.push(localUsageUntilInput as DialogFormInput);
              }
              if(forceOperation === OperationType.OUT) {
                return this.fingerprint.supervision('otherState.delayPay').then((supervisorAccountName: string) => {
                  navToFaceCheck(undefined, undefined, undefined, undefined, supervisorAccountName);
                });
              }

              if(skipPayment) {
                if(useFingerprint || (this.request.getStatusTheme(this.current).actionState !== ActionState.READY_CHECKIN && this.request.getStatusTheme(this.current).actionState !== ActionState.READY_CHECK && (this.current.metadata.BorderPass && this.current.metadata.BorderPass === 'No'))) {
                  navToFaceCheck();
                } else {
                  if(documentTypeIsProvisionalResidencePermit(this.current.operationId)) {
                    navToNoticePrint(undefined, undefined, undefined, NoticeType.RESTRICTION);
                  } else if(this.current.metadata?.Occupation?.toLowerCase()?.includes('media')) {
                    navToNoticePrint(undefined, undefined, undefined, NoticeType.REPORTING);
                  } else if(documentTypeIsExit(this.current.operationId)) {
                    const printBorderPass = () => {
                      this.printDoc(DocsPrintType.BORDER_PASS);

                      this.printSubscription = this.print.printLoaded.subscribe((loaded) => {
                        if(loaded) {
                          this.loader.loading(true, {type: 'question', message: 'print.borderPass.ask', btnLabel: 'global.yes', custom: {closeBtnLabel: 'global.no.retry'}}).then((done: boolean) => {
                            if(done) {
                              if(useNoticePrint) {
                                navToNoticePrint(undefined, RequestCashType.CASH, undefined, NoticeType.REPORTING);
                              } else {
                                navToFaceCheck(undefined, RequestCashType.CASH, undefined, undefined);
                              }
                            } else {
                              this.printSubscription.unsubscribe();
                              return printBorderPass();
                            }
                          });
                        }
                      });
                    };
                    return printBorderPass();
                  } else {
                    if(useNoticePrint) {
                      navToNoticePrint();
                    } else {
                      navToFaceCheck();
                    }
                  }
                }

              } else {
                this.loader.loading(true, {type: 'valid', btnLabel: 'global.confirm', custom: {innerHtml: (documentTypeIsExit(this.current.operationId) ? this.lang.transform('ask.isArrivalPaid.exit') : this.lang.transform('ask.isArrivalPaid')) + this.request.getRatesText(this.current.document.id as DocumentType, this.current.nationality || this.current.metadata.Nationality, this.current.amountCents), icon: 'money-bill-wave'}}).then(done => {
                  if(done) {
                    this.loader.loading(true, {type: 'question', message: (documentTypeIsExit(this.current.operationId) ? 'ask.isArrivalPaid.confirm.exit' : this.lang.transform('ask.isArrivalPaid.confirm', {days: maxDays})), btnLabel: 'yes', custom: {closeBtnLabel: 'no'}, dialogInput}).then((res: any) => {
                      if(res?.localUsageUntil) {
                        res.localUsageUntil = new Date(addDays(startOfToday(), +res.localUsageUntil)).getTime();
                      }
                      if(res && res.paymentReference && (res.cashType || documentTypeIsExit(this.current.operationId)) && res.currency) {
                        if(res.localUsageUntil && (new Date(res.localUsageUntil) < new Date() || new Date(res.localUsageUntil) > addMilliseconds(new Date(), +this.current.localUsageUntilFromServer))) {
                          return this.loader.loading(true, {type: 'error', message: 'error.bad.localUsageUntil'});
                        }
                        if(useFingerprint || (this.request.getStatusTheme(this.current).actionState !== ActionState.READY_CHECKIN && this.request.getStatusTheme(this.current).actionState !== ActionState.READY_CHECK && (this.current.metadata.BorderPass && this.current.metadata.BorderPass === 'No'))) {
                          navToFaceCheck(res.paymentReference, res.cashType, res.currency, res.localUsageUntil);
                        } else {
                          if(documentTypeIsProvisionalResidencePermit(this.current.operationId)) {
                            navToNoticePrint(undefined, undefined, undefined, NoticeType.RESTRICTION, res.localUsageUntil);
                          } else if(this.current.metadata?.Occupation?.toLowerCase()?.includes('media')) {
                            navToNoticePrint(res.paymentReference, res.cashType, res.currency, NoticeType.REPORTING, res.localUsageUntil);
                          } else if(documentTypeIsExit(this.current.operationId)) {
                            const printBorderPass = () => {
                              this.printDoc(DocsPrintType.BORDER_PASS);

                              this.printSubscription = this.print.printLoaded.subscribe((loaded) => {
                                if(loaded) {
                                  this.loader.loading(true, {type: 'question', message: 'print.borderPass.ask', btnLabel: 'global.yes', custom: {closeBtnLabel: 'global.no.retry'}}).then((done: boolean) => {
                                    if(done) {
                                      if(useNoticePrint) {
                                        navToNoticePrint(res.paymentReference, RequestCashType.CASH, res.currency, NoticeType.REPORTING, res.localUsageUntil);
                                      } else {
                                        navToFaceCheck(res.paymentReference, RequestCashType.CASH, res.currency, res.localUsageUntil);
                                      }
                                    } else {
                                      this.printSubscription.unsubscribe();
                                      return printBorderPass();
                                    }
                                  });
                                }
                              });
                            };
                            return printBorderPass();
                          } else {
                            if(useNoticePrint) {
                              navToNoticePrint(res.paymentReference, res.cashType, res.currency, undefined, res.localUsageUntil);
                            } else {
                              navToFaceCheck(res.paymentReference, res.cashType, res.currency, res.localUsageUntil);
                            }
                          }
                        }
                      } else {
                        if(!res) return; // cancelled
                        this.loader.loading(true, {type: 'error', message: 'error.payment.noRefuseReason'});
                      }
                    });
                  }
                });
              }
            }
          } else {
            if(this.current?.chargedBackAt) {
              if(checkoutIsNextOrForce) {
                this.loader.loading(true, {type: 'warn', message: 'client.extended.chargedBack'}).then(() => {
                  const dialogInput = [{
                    formCtrlName: 'paymentReferenceChargedBack',
                    type: 'text',
                    label: 'paymentReference.ask',
                    maxLength: 60,
                    value: uuid.v1()
                  }, {
                    formCtrlName: 'currency',
                    type: 'select',
                    label: 'form.currency',
                    selectOptions: this.api.env.supportedCurrencies
                  }] as DialogFormInput[];
                  this.loader.loading(true, {type: 'info', message: 'ask.chargedBack.confirm', btnLabel: 'global.confirm', custom: {closeBtnLabel: 'no'}, dialogInput}).then((res: any) => {
                    if(res?.paymentReferenceChargedBack && res?.currency) {
                      if(useFingerprint || (this.request.getStatusTheme(this.current).actionState !== ActionState.READY_CHECKIN && this.request.getStatusTheme(this.current).actionState !== ActionState.READY_CHECK && (forceOperation && forceOperation !== OperationType.IN))) {
                        navToFaceCheck(res.paymentReferenceChargedBack, RequestCashType.CASH, res.currency);
                      } else {
                        if(documentTypeIsProvisionalResidencePermit(this.current.operationId)) {
                          navToNoticePrint(undefined, undefined, undefined, NoticeType.RESTRICTION);
                        } else if(this.current.metadata?.Occupation?.toLowerCase()?.includes('media')) {
                          navToNoticePrint(res.paymentReference, res.cashType, res.currency, NoticeType.REPORTING);
                        } else {
                          if(useNoticePrint) {
                            navToNoticePrint(res.paymentReferenceChargedBack, RequestCashType.CASH, res.currency);
                          } else {
                            navToFaceCheck(res.paymentReferenceChargedBack, RequestCashType.CASH, res.currency);
                          }
                        }
                      }
                    } else {
                      this.loader.loading(true, {type: 'error', message: 'error.payment.noReferenceChargedBack'});
                    }
                  });
                });
              } else {
                this.loader.loading(true, {type: 'warn', message: 'client.extended.entryChargedBack'});
              }
            } else {
              const leave = (navToNotice = false) => {
                if(checkoutIsNextOrForce || !this.current.isDeclaration) {
                  if(navToNotice) {
                    navToNoticePrint(undefined, undefined, undefined, NoticeType.REPORTING);
                  } else {
                    navToFaceCheck();
                  }
                } else {
                  const dialogInput = [{
                    formCtrlName: 'localUsageUntil',
                    type: 'text',
                    label: generateDynamicLabel(defaultDays),
                    value: String(defaultDays),
                    validator: [Validators.min(1), Validators.max(maxDays), Validators.required, Validators.pattern('^[0-9]*$')],
                    onChangeAction: (newValue: string) => {
                      const days = Number(newValue);
                      dialogInput[0].label = generateDynamicLabel(days);
                    }
                  }] as DialogFormInput[];
                  this.loader.loading(true, {type: 'info', message: this.lang.transform('ask.localUsageUntil.confirm', {days: maxDays}), btnLabel: 'global.confirm', dialogInput: dialogInput}).then((res: any) => {
                    if(res?.localUsageUntil) {
                      res.localUsageUntil = new Date(addDays(startOfToday(), +res.localUsageUntil)).getTime();
                      if(new Date(res?.localUsageUntil) < new Date() || new Date(res?.localUsageUntil) > addMilliseconds(new Date(), +this.current.localUsageUntilFromServer)) {
                        return this.loader.loading(true, {type: 'error', message: 'error.bad.localUsageUntil'});
                      } else {
                        navToNotice ? navToNoticePrint(undefined, undefined, undefined, undefined, res.localUsageUntil) :  navToFaceCheck(undefined, undefined, undefined, res.localUsageUntil);
                      }
                    }
                  });
                }
              };
              if(useFingerprint || (this.request.getStatusTheme(this.current).actionState !== ActionState.READY_CHECKIN && this.request.getStatusTheme(this.current).actionState !== ActionState.READY_CHECK && (forceOperation && forceOperation !== OperationType.IN))) {
                leave(useNoticePrint);
              } else {
                if(documentTypeIsProvisionalResidencePermit(this.current.operationId)) {
                  navToNoticePrint(undefined, undefined, undefined, NoticeType.RESTRICTION);
                } else if(this.current.metadata?.Occupation?.toLowerCase()?.includes('media')) {
                  navToNoticePrint(undefined, undefined, undefined, NoticeType.REPORTING);
                } else {
                  if(useNoticePrint) {
                    if(this.current.isDeclaration) {
                      leave(true);
                    } else {
                      navToNoticePrint(undefined, undefined, undefined, documentTypeIsExit(this.current.operationId) ?  NoticeType.REPORTING : undefined);
                    }
                  } else {
                    leave();
                  }
                }
              }
            }
          }
        }
      };
      if(!this.current.usageUntilValid) {
        if(this.request.getStatusTheme(this.current).actionState === ActionState.READY_CHECKIN || this.request.getStatusTheme(this.current).actionState === ActionState.READY_CHECK || forceOperation === OperationType.IN) {
          return this.loader.loading(true, {type: 'warn', custom: {innerHtml: this.lang.transform(this.isCatEasy ? 'outUsage.AB' : 'outUsage.C')}});
        }
      }

      if(!this.current.localUsageUntilValid && (!(this.request.getStatusTheme(this.current).actionState === ActionState.READY_CHECKIN) && !(this.request.getStatusTheme(this.current).actionState === ActionState.READY_CHECK)) && !refuse) {
        const gracePeriodMillis = this.api.userInfo.server.maxOverstayGraceMillis;
        const gracePeriodDate = endOfDay(addMilliseconds(endOfDay(new Date(this.current.localUsageUntil)), gracePeriodMillis));
        const today = endOfDay(new Date());
        const isInGracePeriod = isBefore(today, gracePeriodDate) || isEqual(gracePeriodDate, today);

        const actionExpired = () => {
          const dialogInput = [{
            formCtrlName: 'paymentReference',
            type: 'text',
            label: 'paymentReference.askExpired',
            maxLength: 60,
            validator: [Validators.required],
            value: uuid.v1()
          },
          {
            formCtrlName: 'currency',
            type: 'select',
            validator: [Validators.required],
            label: 'form.currency',
            selectOptions: this.api.env.supportedCurrencies
          }] as DialogFormInput[];
          if(forceOperation === OperationType.IN) {
            return this.fingerprint.supervision('otherState.overStay').then((supervisorAccountName: string) => {
              navToFaceCheck(undefined, undefined, undefined, undefined, supervisorAccountName);
            });
          }
          this.loader.loading(true, {type: 'warn', btnLabel: 'global.confirm', custom: {innerHtml: this.lang.transform('expiredSinceTime', {days: this.diffDays, hours: this.diffHours}) + this.lang.transform('error.paymentUntil.expired') + this.request.getRatesText(this.current.document.id as DocumentType, this.current.nationality || this.current.metadata.Nationality, this.api.userInfo.server.paymentNonDocumentsCents.overstay || this.current.amountCents, true)}}).then((done) => {
            if(done) {
              this.loader.loading(true, {type: 'info', message: 'ask.checkoutExpired.confirm', btnLabel: 'global.confirm', custom: {closeBtnLabel: 'no'}, dialogInput}).then((res: any) =>{
                if(res?.paymentReference && res?.currency) {
                  if(useNoticePrint) {
                    navToNoticePrint(res.paymentReference, RequestCashType.CASH, res.currency, NoticeType.REPORTING, undefined, true);
                  } else {
                    navToFaceCheck(res.paymentReference, RequestCashType.CASH, res.currency, undefined, undefined, true);
                  }
                }
              });
            }
          });
        };

        //if the user is in the grace period then ask if they should pay or not
        if(isInGracePeriod) {
          this.loader.loading(true, {type: 'warn', btnLabel: 'apply.overstay', custom: {innerHtml: this.lang.transform('paymentUntil.gracePeriod', {date: format(gracePeriodDate, 'dd/MM/yyyy HH:mm')}), closeBtnLabel: 'no_apply.overstay'}}).then((done) => {
            if(done) {
              actionExpired();
            } else {
              if(useNoticePrint) {
                navToNoticePrint(undefined, undefined, undefined, NoticeType.REPORTING);
              } else {
                navToFaceCheck();
              }
            }
          });
        } else {
          actionExpired();
        }
      } else {
        if(!this.current.usageAfterValid) {
          this.loader.loading(true, {type: 'warn', message: this.lang.transform('error.paymentUntil.before', {dateAfter: format(this.current.usageAfter, 'dd/MM/yyyy HH:mm')} )});
        } else {
          if(this.current.metadata.ExistingValidEntryReference && this.current.state === RequestState.DELAY_PAY && this.current.amountCents > 0 && !this.request.isPaidOnline(this.current.document.id, this.current.metadata)) {
            this.loader.loading(true, {type: 'warn', btnLabel: 'continue', custom: {innerHtml: this.lang.transform('existingValidEntryReference.desc'), closeBtnLabel: 'no.must_pay'}, shortcut: {closeBtn: {action: ' ' as ShortcutAction}}}).then((done) => {
              if(done) {
                consume(true);
              } else {
                consume();
              }
            });
          } else {
            consume();
          }
        }
      }
    };

    if(this.api.isElectronApp && useFingerprint) {
      if(electron.addon.hasSystemFingerprint()) {
        consumeAction(true);
      } else {
        this.loader.loading(true, {type: 'warn', message: this.lang.transform('fingerprint.notAvailable')}).then(() => {
          consumeAction();
        });
      }
    } else {
      consumeAction();
    }
  }

  goToPreviousUrl() {
    if(this.fromRoute === 'scanQr') {
      this.nav.to('scan-qr');
    } else {
      this.router.navigateByUrl(localStorage.getItem('previous_url'));
    }
  }

  formatDate(date: string) {
    return format(parseISO(date), 'HH:mm dd/MM/yyyy');
  }

  toggleSelectMode(setBool?: boolean) {
    if(setBool !== undefined) {
      this.selectMode = setBool;
    } else {
      this.selectMode = !this.selectMode;
    }
    if(this.selectMode) {
      this.loader.loading(true, {type: 'info', message: this.lang.transform('payment.selectMode')});
    } else {
      this.selectedFields = [];
    }
  }

  suspendPayment() {
    if(!this.selectedFields.length) {
      this.toggleSelectMode(true);
      return;
    }
    const dialogInput = [{
      formCtrlName: 'refusalReason',
      type: 'textarea',
      validator: [Validators.required],
      label: 'refusal.desc.DYN.',
      maxLength: 200
    }] as DialogFormInput[];

    this.loader.loading(true, {type: 'warn', message: 'suspendReason.desc', dialogInput: dialogInput, shortcut: {btn: {action: ' ' as ShortcutAction}}}).then((res: any) => {
      if(res?.refusalReason) {
        this.loader.loading(true);
        return this.api.suspendPayment(this.current?.id, true, res.refusalReason, this.selectedFields, this.api.userPlaceId).then(() => {
          this.loader.loading(false);
          this.nav.to('admin-request');
        }).catch(() => {
          this.loader.loading(true, {type: 'error', message: ('error.payment.suspend.error.DYN.')});
        });
      } else {
        this.loader.loading(true, {type: 'error', message: 'error.payment.noSuspendReason'});
      }
    });
  }

  validateOrRefusePayment(refuse = false, review = false) {
    this.toggleSelectMode(false);
    const dialogInput: DialogFormInput[] = [
      {
        formCtrlName: 'refusalReason',
        type: 'textarea',
        label: (review ? (refuse ? (this.current.isExtension ? 'review.refusal.desc.extension.DYN.' : 'review.refusal.desc.DYN.') : (this.current.isExtension ? 'review.approval.desc.extension.DYN.' : 'review.approval.desc.DYN.')) :  refuse ? (this.current.isExtension ? 'refusal.desc.extension.DYN.' : 'refusal.desc.DYN.') : (this.current.isExtension ? 'approval.desc.extension.DYN.' : 'approval.desc.DYN.')),
        maxLength: 200,
        validator: refuse ? [Validators.required] : []
      }
    ];

    if(!this.current.isExtension && !review && !refuse && !this.api.env.useGuichet) {
      dialogInput.push({
        formCtrlName: 'usageUntil',
        type: 'date',
        label: 'approval.usageUntil.DYN.',
        value: format(new Date(this.current.usageUntil), 'yyyy-MM-dd'),
        date: {
          dateShowPickerOnClick: true,
          minDate: format(addDays(new Date(this.current.usageAfter), 1), 'yyyy-MM-dd'),
          autoMinMaxDate: true
        }
      });
    }

    if(this.current.isExtension && !refuse && this.current.metadata.DaysRequested) {
      dialogInput.push({
        formCtrlName: 'daysGranted',
        type: 'number',
        label: 'approval.daysGranted.DYN.',
        value: this.current.metadata.DaysRequested,
        validator: [Validators.required, Validators.min(1), Validators.max(this.current.metadata.DaysRequested)]
      });
    }

    const loadingMessage = review ? (refuse ? 'refusalReason.review.desc.DYN.' : 'approveReason.review.desc.DYN.') : refuse ? (this.current.isExtension ? 'refusalReason.desc.extension.DYN.' : 'refusalReason.desc.DYN.') : (this.current.isExtension ? 'payment.validate.extension.ask.DYN.' : 'payment.validate.ask.DYN.');
    this.loader.loading(true, {type: 'info', dialogInput: dialogInput, custom: {innerHtml: this.lang.transform(this.api.env.useGuichet ? loadingMessage : (loadingMessage + 'visa'))}}).then((res: any) => {
      if(this.current.isExtension && !refuse) {
        if(!res?.daysGranted || res.daysGranted <= 0) {
          return this.loader.loading(true, {type: 'error', message: this.lang.transform('approval.daysGranted.error', {days: this.current.metadata.DaysRequested})});
        }
        if(this.current.metadata.DaysRequested && res.daysGranted > this.current.metadata.DaysRequested) {
          return this.loader.loading(true, {type: 'error', message: this.lang.transform('approval.daysGranted.limit', {days: this.current.metadata.DaysRequested})});
        }
      }
      if(new Date(res?.usageUntil) < new Date(addDays(this.current.usageAfter, 1))) {
        return this.loader.loading(true, {type: 'error', message: 'client.extended.minUsageNotMet'});
      }
      if((refuse && res?.refusalReason) || !refuse) {
        const confirmationMessage = refuse ? (this.current.isExtension ? 'payment.review.refuse.ask.extension.DYN.' : 'payment.review.refuse.ask.DYN.') : (this.current.isExtension ? 'payment.review.approve.extension.ask.DYN.' : 'payment.review.approve.ask.DYN.');
        if(review) {
          this.loader.loading(true, {type: 'info', custom: {innerHtml: this.lang.transform(confirmationMessage)}, btnLabel: this.lang.transform('global.confirm')}).then((done) => {
            if(done) {
              this.validatePaymentAndNavigate(this.current?.id, this.api.userPlaceId, refuse, res.refusalReason, res?.usageUntil, res?.daysGranted);
            }
          });
        } else {
          this.validatePaymentAndNavigate(this.current?.id, this.api.userPlaceId, refuse, res.refusalReason, res?.usageUntil, res?.daysGranted);
        }
      } else {
        this.loader.loading(true, {type: 'error', custom: {innerHtml: this.lang.transform('error.payment.noRefuseReason')}});
      }
    });
  }

  validatePaymentAndNavigate(paymentId: string, userPlaceId: string, refuse: boolean, refusalReason: string, usageUntil?: Date, daysGranted?: number) {
    this.loader.loading(true);
    const isDirectConsume: boolean = this.current.isExtension && !refuse && (documentTypeIsVisaExtAB(this.current.operationId) ? true : (this.seniorityLevel === 3 && ((this.current.state === RequestState.PAID_NOT_CONFIRMED && (this.current.subState === RequestSubState.REVISIONS_1 || this.current.subState === RequestSubState.REVISIONS_2)) || (this.current.state === RequestState.EXPIRED && this.current.subState === RequestSubState.REVISIONS_0))));

    if(paymentId) {
      const consumeCall: ApiCall = {
        methodName: 'consumePayment',
        params: [
          paymentId,
          userPlaceId,
          '{{consumeAfterDate}}',
          this.current.created_place_id,
          new Date(this.current.createdAt),
          '',
          {DaysGranted: Number(daysGranted)},
          undefined,
          false,
          environment.appVersion.join('.')
        ],
        useResultFromPrevious: {
          consumeAfterDate: {
            path: 'completionDate',
            addMilliseconds: 20000
          }
        }
      };

      if(isDirectConsume) {
        return this.queue.addToQueue('validatePayment', [paymentId, userPlaceId, refuse, refusalReason, usageUntil ? new Date(usageUntil) : undefined, environment.appVersion.join('.')], 5000, [consumeCall], undefined, true).then(() => {
          setTimeout(() => {
            if(this.api.env.useGuichet && refuse){
              this.api.cancelTimeslot(paymentId);
            }
            this.storage.removeFromStorage(Store.PAYMENT_STORE, this.paymentId);
            if(this.fromRoute) {
              this.nav.to(this.fromRoute);
            } else {
              this.nav.to(this.current.metadata.VisaReference ? 'admin-request-select/' + this.current.metadata.VisaReference : 'admin-request');
            }
          }, 1000);
        });
      } else {
        return this.queue.addToQueue('validatePayment', [paymentId, userPlaceId, refuse, refusalReason, usageUntil ? new Date(usageUntil) : undefined, environment.appVersion.join('.')], 5000).then(() => {
          if(this.api.env.useGuichet && refuse){
            this.api.cancelTimeslot(paymentId);
          }
          if(this.fromRoute) {
            this.nav.to(this.fromRoute);
          } else {
            this.nav.to('admin-request');
          }
        });
      }

    } else {
      const validateCall: ApiCall = {
        methodName: 'validatePayment',
        params: [
          '{{paymentId}}',
          userPlaceId,
          refuse,
          refusalReason,
          usageUntil ? new Date(usageUntil) : undefined,
          environment.appVersion.join('.')
        ],
        useResultFromFirst: {
          paymentId: 'ids[0]'
        }
      };

      const consumeCall: ApiCall = {
        methodName: 'consumePayment',
        params: [
          '{{paymentId}}',
          userPlaceId,
          '{{consumeAfterDate}}',
          this.current.created_place_id,
          new Date(this.current.createdAt),
          '',
          {DaysGranted: Number(daysGranted)},
          undefined,
          false,
          environment.appVersion.join('.')
        ],
        useResultFromFirst: {
          paymentId: 'ids[0]',
          consumeAfterDate: {
            path: 'completionDate',
            addMilliseconds: 20000
          }
        }
      };

      if(isDirectConsume) {
        validateCall.dependentCalls = [consumeCall];
        return this.queue.addDependantCallToExistingQueue(this.current.queueId, validateCall).then(() => {
          setTimeout(() => {
            this.storage.removeFromStorage(Store.PAYMENT_STORE, this.paymentId);
            if(this.fromRoute) {
              this.nav.to(this.fromRoute);
            } else {
              this.nav.to(this.current.metadata.VisaReference ? 'admin-request-select/' + this.current.metadata.VisaReference : 'admin-request');
            }
          }, 1000);
        });
      } else {
        return this.queue.addDependantCallToExistingQueue(this.current.queueId, validateCall).then(() => {
          if(this.fromRoute) {
            this.nav.to(this.fromRoute);
          } else {
            this.nav.to('admin-request');
          }
        });
      }
    }
  }

  visualFile(file?:string, name?: string) {
    this.showDocuments = file ? [{nameDocument: name, document: file, title: name}] : this.metadataDocuments;
    this.visualizerIndex = name;
    if(this.showDocuments.length) this.openDialogDocViewer();
  }

  openDialogDocViewer() {
    this.dialogs.openDialog(DialogDocViewerComponent, 'full', {documentsInput: this.showDocuments, beginIndex: this.visualizerIndex}, false, undefined, true).then(() => {
      this.showDocuments = [];
      this.visualizerIndex = '';
    });
  }

  duplicatePayment() {
    if(this.current?.state === RequestState.USED) {
      this.loader.loading(true, {type: 'warn', message: this.lang.transform('payment.duplicate.ask'), btnLabel: this.lang.transform('global.confirm')}).then((done) =>{
        if(done) {
          this.loader.loading(true);
          const batchId = this.cart.getUniqueReference([]); // Need to generate a new batchId because of unique constraint in DB
          this.api.duplicatePayment(this.current.id, this.api.userPlaceId, batchId).then((res: any) => {
            this.loader.loading(false);
            this.loader.loading(true, {type: 'info', message: this.lang.transform('payment.duplicate.done'), btnLabel: this.lang.transform('payment.duplicate.open')}).then((done) => {
              if(done) {
                this.nav.to('admin-request-select/' + res.result);
              } else {
                this.getPayment();
              }
            });
          }).catch((err) => {
            this.loader.loading(true, {type: 'error', message: err});
          });
        }
      });
    } else {
      this.loader.loading(true, {type: 'error', message: this.lang.transform('payment.paid.error')});
    }
  }

  refundPayment() {
    if(this.current?.state === 1) {
      if(!this.current.refunded_place_id) {
        if(this.api.userRole.isCustomer) {
          this.loader.loading(true, {type: 'warn', message: this.lang.transform('payment.refund.ask'), btnLabel: this.lang.transform('global.confirm')}).then((done) =>{
            if(done) {
              this.loader.loading(true);
              this.api.selfRefundPayment(this.current.id).then(() => {
                this.loader.loading(false);
                this.loader.loading(true, {type: 'info', message: this.lang.transform('payment.refund.done')}).then(() =>{
                  this.getPayment();
                });
              }).catch((err) => {
                this.loader.loading(true, {type: 'error', message: err});
              });
            }
          });
        } else {
          this.loader.loading(true, {type: 'warn', message: this.lang.transform('payment.refund.ask'), btnLabel: this.lang.transform('global.confirm')}).then((done) =>{
            if(done) {
              this.loader.loading(true);
              this.api.refundPayment(this.current.id, this.api.userPlaceId).then(() => {
                this.loader.loading(false);
                this.loader.loading(true, {type: 'info', message: this.lang.transform('payment.refund.done')}).then(() =>{
                  this.nav.to('admin-request');
                });
              }).catch((err) => {
                this.loader.loading(true, {type: 'error', message: err});
              });
            }
          });
        }
      } else {
        this.loader.loading(true, {type: 'error', message: this.lang.transform('payment.refund.exist')});
      }
    } else {
      this.loader.loading(true, {type: 'error', message: this.lang.transform('payment.paid.error')});
    }
  }

  goToDuplicata() {
    this.nav.to('admin-request-select/' + this.current?.duplicatas[0].id);
  }

  getAmount(currency: keyof typeof CurrencySign, amount: number, millis = true) : string{
    return CurrencySign[currency] + (millis ? amount / 100 : amount);
  }

  getPaymentType(currency: keyof typeof RequestCashType) : string{
    return RequestCashType[currency];
  }

  setForm() {
    this.form = this.formBuilder.group({deportedMode: ['', []]});
  }

  checkSelect($event: Event, control: VisaFN, noPointer?: boolean) {
    noPointer && $event.preventDefault();
    $event.stopPropagation();
    this.selectedFields = ($event.target as any).checked ? [...this.selectedFields, control] : this.selectedFields.filter(c => c !== control);
  }

  canBeValidated(approveRefuseButtons= false) {
    const eventOfPayment = this.current.events.length;
    if(approveRefuseButtons) {
      if(this.api.hasPerm(UserPermission.ALLOW_ADMIN)) {
        if(this.current.state === RequestState.DELAY_PAY || this.current.state === RequestState.PAID) {
          return true;
        }
        return eventOfPayment > 2;
      } else {
        return false;
      }
    } else {
      if(this.api.hasPerm(UserPermission.ALLOW_ADMIN)) {
        return this.current.actualManualConfirmRounds > eventOfPayment && !approveRefuseButtons;
      } else {
        if(this.api.hasPerm(UserPermission.ALLOW_CONTROL)) {
          if(this.current.events.find(payment => payment.actor_id === this.api.userInfo.id)) {
            return false;
          } else {
            return this.current.actualManualConfirmRounds > eventOfPayment;
          }
        } else {
          return false;
        }
      }
    }
  }

  reviewPayment() {
    const err = checkVisaPreconditions(this.current);
    if(err) {
      this.loader.loading(true, {type: 'warn', message: err});
      return;
    }

    const dialogInput = [{
      formCtrlName: 'approveRefuse',
      type: 'select',
      label: 'recommendOrNot',
      validator: [Validators.required],
      selectOptions: [{
        name: 'recommended',
        value: 0
      },
      {
        name: 'not_recommended',
        value: 1
      }]
    }] as DialogFormInput[];
    this.loader.loading(true, {type: 'question', custom: {innerHtml: this.lang.transform((this.current.isExtension ? 'ask.review.extension.' : 'ask.review.') + this.current.subState)}, buttonType: 'button', dialogInput: dialogInput}).then((res: any) => {
      if(res) {
        if(!res?.approveRefuse) {
          this.loader.loading(true, {type: 'error', message: 'error.review.noChoice'});
        } else {
          if(+res?.approveRefuse === 0) {
            this.validateOrRefusePayment(undefined, true);
          } else if(+res?.approveRefuse === 1) {
            this.validateOrRefusePayment(true, true);
          }
        }
      }
    });
  }

  JSONparse(data: string) {
    try {
      return JSON.parse(data);
    } catch (e) {
      return false;
    }
  }

  hasNextOfKinData(): boolean {
    const raw = this.current?.metadata?.NextOfKin;
    if(!raw || raw === '{}') return false;
    const parsed = this.JSONparse(raw);
    if(!parsed) return false;
    return !!(parsed.firstname || parsed.lastname || parsed.phone || parsed.email);
  }

  isEvent() {
    return this.current?.events.some(event => event.type === PlatformEventType.PAYMENT_VALIDATED || event.type === PlatformEventType.PAYMENT_REFUSED || (event.type === PlatformEventType.PAYMENT_UPDATED && isJsonParsable(event.context)?.newOperation) || (event.type === PlatformEventType.PAYMENT_UPDATED && !event.place_id) || event.type === PlatformEventType.PAYMENT_SUSPEND_CHANGE);
  }

  isSupervisionEvent() {
    return this.current?.events.some(event => event.type === PlatformEventType.PAYMENT_USED && event.consumeData?.Operation);
  }

  hasInOperationEvent(): boolean { // Checks if there is any event with OperationType.IN in the current moveEvents
    return this.current?.moveEvents?.some(event => event.consumeData?.Operation === OperationType.IN) ?? false;
  }

  /**
  * Checks if the selected tab entry is the virtual unknown officer entry
  * @param index - The index of the selected tab
  * @returns boolean - true if it's the unknown officer entry
  */
  isUnknownOfficerEntry(index: number): boolean {
    const entries = this.getTabEntries();
    return (entries[index] as {isUnknownOfficer: boolean; consumeData: { Operation: OperationType }})?.isUnknownOfficer === true;
  }

  /**
  * Gets combined array of move events and unknown officer entry for tab display
  * @returns Array of events or virtual entries for tab navigation
  */
  getTabEntries(): Array<PlatformEvent | { isUnknownOfficer: boolean; consumeData: { Operation: OperationType } }> {
    if(!this.current?.moveEvents) {
      return [];
    }
    const entries: Array<PlatformEvent | { isUnknownOfficer: boolean; consumeData: { Operation: OperationType } }> = [...this.current.moveEvents];
    if(!this.hasInOperationEvent()) { // Add virtual "unknown officer" entry if no IN operation exists
      entries.push({isUnknownOfficer: true, consumeData: {Operation: OperationType.IN}
      });
    }
    return entries;
  }

  getLogicalIndex(i: number): number {
    const entries = this.getTabEntries();
    let count = 1;
    for(let j = 0; j < i; j++) {
      const op = entries[j].consumeData?.Operation;
      if(op === OperationType.OUT || op === OperationType.REFUSEOUT || op === OperationType.INRETURNED) {
        count++;
      }
    }
    return count;
  }

  printDoc(docName: AllDocumentsPrintType) {
    switch(docName) {
    case DocsPrintType.APPLICATION:
      const applicationData: PrintApplicationData = {
        title: this.lang.transform(documentTypeIsVisaExtAB(this.current.operationId) || documentTypeIsVisaExtC(this.current.operationId) ? 'titlePrint.extension' : ( documentTypeIsPassport(this.current.operationId) || documentTypeIsIdentityCard(this.current.operationId) || documentTypeIsResidenceCard(this.current.operationId) ) ? this.current.operationId + '.titlePrint' : 'titlePrint', {paymentID: this.offlineApplication ? 'OFFLINE' : this.current.id}),
        dataList: this.printVisaApplication,
        request: this.current
      };
      const printAll = () => {
        this.loader.loading(true);
        mergeDocuments(this.metadataDocuments).then((mergedPdfBytes) => {
          const blob = new Blob([mergedPdfBytes], {type: 'application/pdf'});
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
          this.api.lockPayment(this.current.id, undefined, true, '', this.api.userPlaceId).then().catch((err) => console.log(err));
          this.print.print<PrintApplicationData>(DocsPrintType.APPLICATION, applicationData);
          this.loader.loading(false);
        }).catch(() => {
          this.loader.loading(false);
        });
      };
      if(this.metadataDocuments.length) {
        this.loader.loading(true, {
          type: 'info',
          message: 'print.askMultiple',
          btnLabel: 'yes',
          custom: {icon: 'print', closeBtnLabel: 'no'}
        }).then((done: boolean) => {
          if(done) {
            if(!this.api.isElectronApp && this.getPrintEvents().length) {
              const lastPrint: PlatformEvent = this.getPrintEvents().sort((a, b) => a.updatedOn.localeCompare(b.updatedOn)).pop();
              this.loader.loading(true, {type: 'warn', message: this.lang.transform('print.alreadyPrinted', {date: format(lastPrint.updatedOn, 'dd/MM/yyyy HH:mm'), user: this.sync.userDisplay(lastPrint.actor_id)+' #'+lastPrint.actor_id}), btnLabel: 'yes', custom: {closeBtnLabel: 'no'}}).then((done: boolean) => {
                if(done) {
                  printAll();
                } else {
                  this.print.print<PrintApplicationData>(DocsPrintType.APPLICATION, applicationData);
                }
              });
            } else {
              printAll();
            }
          } else {
            this.print.print<PrintApplicationData>(DocsPrintType.APPLICATION, applicationData);
          }
        });
      } else {
        this.print.print<PrintApplicationData>(DocsPrintType.APPLICATION, applicationData);
      }
      break;
    case DocsPrintType.APPROVAL_LETTER:
      const baseHref = this.environment.baseHref === '' ? '/' : this.environment.baseHref + 'index.html';
      this.current.qrCodeVerification = window.location.origin + baseHref + '#/qr/' + this.paymentId + '?from=ScanQR';
      this.print.print<RequestWithDuplicata>(DocsPrintType.APPROVAL_LETTER, this.current);
      break;
    case DocsPrintType.RECEIPT:
      const print = (receipt: PrintReceiptData) => {
        const receiptData: PrintReceiptData = {...receipt, qrCode: this.current.qrCode}; this.print.print<PrintReceiptData>(DocsPrintType.RECEIPT, receiptData);
      };
      if(this.printReceiptData.length > 0) {
        if(this.printReceiptData.length === 1) {
          const receipt = this.printReceiptData[0];
          this.loader.loading(true, {type: 'info', btnLabel: 'global.yes', custom: {innerHtml: this.lang.transform('ask.printReceipt', {date: format(receipt.datePrint, 'dd/MM/yyyy HH:mm')}), icon: 'print'}}).then((res: boolean) => {
            if(res) return print(receipt);
          });
        } else {
          this.selectOptions = this.printReceiptData.map((receipt, i) => ({
            name: `${this.lang.transform('operation.' + receipt.operation)} - ${format(receipt.datePrint, 'dd/MM/yyyy HH:mm')}`,
            value: i
          }));

          const defaultSelectionOptions =  this.selectOptions.length === 1 ? {name: this.selectOptions[0].name, value: String(this.selectOptions[0].value)} : undefined;
          const dialogInput = [
            {
              formCtrlName: 'selectedReceipt',
              type: 'select',
              validator: [Validators.required],
              label: 'select.receipt',
              defaultSelectionOptions,
              selectOptions: this.selectOptions
            }
          ] as DialogFormInput[];
          this.loader.loading(true, {type: 'question', message: 'ask.selectReceipt', btnLabel: 'global.confirm', custom: {closeBtnLabel: 'global.cancel', icon: 'print'}, dialogInput}).then((res: any) => {
            if(res?.selectedReceipt) {
              const selectedReceipt = this.printReceiptData[res.selectedReceipt];
              print(selectedReceipt);
            } else if(res === undefined) {
              this.loader.loading(true, {type: 'error', message: 'noChoice.selectedReceipt'});
            }
          });
        }
      }
      break;
    case DocsPrintType.STICKER:
      if(this.otherStateAction && this.current.usageCount === 0) {
        this.fingerprint.supervision('printOtherStateSticker').then(() => {
          this.print.printSticker(this.current, undefined, undefined, this.scanDocument.scanDatas?.fields);
        });
      } else {
        this.fingerprint.supervision('reprintSticker').then(() => {
          this.print.printSticker(this.current, undefined,
            new Date([...this.current.events].reverse().find(e => e.type === PlatformEventType.PAYMENT_USED && e.indexed.Operation === 'IN').updatedOn), this.scanDocument.scanDatas?.fields);
        });
      }
      break;

    case DocsPrintType.BORDER_PASS:
      this.print.print<PrintBorderpassData>(DocsPrintType.BORDER_PASS, this.printBorderPassData);
      break;
    case DocsPrintType.DECISION_LETTER:
      this.preparePrintDecisionLetter();
      this.print.print<PrintDecisionLetterData>(DocsPrintType.DECISION_LETTER, this.printDecisionLetterData);
      break;
    }
  }

  getReviewNr(event: PlatformEvent) {
    let events = this.current?.events.filter(e => e.type === PlatformEventType.PAYMENT_VALIDATED || e.type === PlatformEventType.PAYMENT_REFUSED);
    if(events && event.type === PlatformEventType.PAYMENT_VALIDATED || event.type === PlatformEventType.PAYMENT_REFUSED) {
      events.sort((a, b) => a.updatedOn.localeCompare(b.updatedOn));
      if(events.length > 2) {
        if(event.id === events[events.length - 1].id) {
          return this.lang.transform('review.nr.final') + ': ';
        } else {
          events = events.slice(0, 2);
          return events.indexOf(event) > -1 ? this.lang.transform('review.nr') + (events.indexOf(event) + 1)+ ': ' : '';
        }
      } else {
        return this.lang.transform('review.nr') + (events.indexOf(event) + 1)+ ': ';
      }
    }
  }

  goBack() {
    if(this.offlineApplication) {
      this.quitOfflineApplication();
    } else {
      if(this.fromRoute !== 'admin-request' && !this.fromRoute?.includes('admin-request-select')) {
        this.fromRoute ? this.nav.to(this.fromRoute) : this.nav.to('admin-request');
      } else {
        this.nav.to('admin-request', undefined, {queryParams: this.searchParams});
      }
    }
  }

  canBeReviewed() {
    if(this.api.userInfo.role === UserPlatformRole.ADMIN) {
      return this.hasUiPerm.call(this, UiPermission.EVALUATE_CAN_BEREVIEWED_ADMIN);
    }
    if(evaluateCanBeReviewed(this.current, this.api.userInfo)) {
      if(this.api.hasPerm(UserPermission.ALLOW_CONTROL) && !this.current.isExtension && (this.current.state === RequestState.PAID_NOT_CONFIRMED || this.current.state === RequestState.DELAY_PAY_NOT_CONFIRMED)) {
        if(documentTypeIsVisaExtAB(this.current.operationId)) {
          return false;
        } else if(this.current.events?.find(payment => (this.seniorityLevel !== 3 && payment.actor_id === this.api.userInfo.id) && (payment.type === PlatformEventType.PAYMENT_VALIDATED || payment.type === PlatformEventType.PAYMENT_REFUSED))) {
          return false;
        } else {
          const subState = this.current.subState;
          if((subState === RequestSubState.REVISIONS_0 && (this.seniorityLevel === 1 || this.seniorityLevel === 3)) || (this.seniorityLevel === 2 && documentTypeIsVisaExtC(this.current.operationId) && subState === RequestSubState.REVISIONS_0)) {
            return true;
          } else if((subState === RequestSubState.REVISIONS_1 && !documentTypeIsVisaExtC(this.current.operationId)) && (this.seniorityLevel === 2 || this.seniorityLevel === 3)) {
            return true;
          }
          return false;
        }
      }
    } else {
      return false;
    }
    if(this.api.hasPerm(UserPermission.ALLOW_EXTENSION) && this.current.isExtension && (this.current.state === RequestState.PAID_NOT_CONFIRMED || this.current.state === RequestState.DELAY_PAY_NOT_CONFIRMED)) {
      if(documentTypeIsVisaExtAB(this.current.operationId)) {
        return false;
      } else if(this.current.events?.find(payment => (payment.actor_id === this.api.userInfo.id) && (payment.type === PlatformEventType.PAYMENT_VALIDATED || payment.type === PlatformEventType.PAYMENT_REFUSED))) {
        return false;
      } else {
        const subState = this.current.subState;
        if((subState === RequestSubState.REVISIONS_0 && (this.seniorityLevel === 1 || this.seniorityLevel === 3)) || (this.seniorityLevel === 2 && documentTypeIsVisaExtC(this.current.operationId) && subState === RequestSubState.REVISIONS_0)) {
          return true;
        } else if((subState === RequestSubState.REVISIONS_1 && !documentTypeIsVisaExtC(this.current.operationId)) && (this.seniorityLevel === 2 || this.seniorityLevel === 3)) {
          return true;
        }
        return false;
      }
    }
    return false;
  }

  canBeAcceptedRefused(refuse = false) {
    if(this.api.env.useGuichet && this.api.env.formHasBookTimeSlotStep) {
      if(!this.current.timeslot) return false;
      const today = new Date().setHours(0, 0, 0, 0);
      const timeslot = new Date(this.current.timeslot).setHours(0, 0, 0, 0);
      if(today > timeslot) return false;
    } else if(!this.api.env.useGuichet) {
      if(!this.current.usageUntilValid) return false;
    }
    const hasAlreadyDoneAction = this.current.events?.find(payment => (this.seniorityLevel !== 3 && payment.actor_id === this.api.userInfo.id) && (payment.type === PlatformEventType.PAYMENT_VALIDATED || payment.type === PlatformEventType.PAYMENT_REFUSED || payment.type === PlatformEventType.PAYMENT_CREATED));
    if(this.api.hasPerm(UserPermission.ALLOW_CONSUME) && !this.selectMode && (this.seniorityLevel === 1 || this.seniorityLevel === 2) && documentTypeIsVisaExtAB(this.current.operationId)) {
      return !hasAlreadyDoneAction && (refuse ? this.request.getStatusTheme(this.current).actionState === ActionState.REFUSED ? false : true : true);
    }
    if(this.api.hasPerm(UserPermission.ALLOW_CONTROL) && this.seniorityLevel === 3 && !this.selectMode && !documentTypeIsEntry(this.current.operationId)) {
      if(this.current.state === RequestState.PAID && !documentTypeIsExit(this.current.operationId)) {
        return refuse ? !hasAlreadyDoneAction : false;
      } else if(this.current.state === RequestState.EXPIRED) {
        return refuse ? false : !hasAlreadyDoneAction;
      } else {
        if(this.current.state === RequestState.PAID_NOT_CONFIRMED || this.current.state === RequestState.DELAY_PAY_NOT_CONFIRMED) {
          if(documentTypeIsVisaExtAB(this.current.operationId) || (documentTypeIsVisaExtC(this.current.operationId) && this.current.subState === RequestSubState.REVISIONS_1)) {
            return true;
          }
          if(hasAlreadyDoneAction) {
            return false;
          }
          return evaluateCanBeAcceptedRefused(this.current) ;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  canBeSuspended() {
    if(this.api.env.useGuichet && this.api.env.formHasBookTimeSlotStep) {
      if(!this.current.timeslot) return false;
      const today = new Date().setHours(0, 0, 0, 0);
      const timeslot = new Date(this.current.timeslot).setHours(0, 0, 0, 0);
      if(today > timeslot) return false;
    } else if(!this.api.env.useGuichet) {
      if(!this.current.usageUntilValid) return false;
    }
    if(!this.current.usageUntilValid) return false;
    if(this.current.isExtension) {
      if(!this.api.hasPerm(UserPermission.ALLOW_EXTENSION)) return false;
    } else {
      if(!this.api.hasPerm(UserPermission.ALLOW_CONTROL)) return false;
    }
    return this.current.state === RequestState.PAID_NOT_CONFIRMED || this.current.state === RequestState.DELAY_PAY_NOT_CONFIRMED;
  }

  canBeConsumed(refused = false) {
    if(this.offlineApplication && !documentTypeIsVisaExtAB(this.current.operationId)  && !documentTypeIsVisaExtC(this.current.operationId)) return true;

    if(this.current.subState === RequestSubState.CLOSED) {
      return false;
    }
    if(this.isSyncing) {
      return false;
    }
    if(documentTypeIsVisaExtAB(this.current.operationId)  || documentTypeIsVisaExtC(this.current.operationId) ) {
      return false;
    }
    const hasPermissionAndValidState = this.api.hasPerm(UserPermission.ALLOW_CONSUME) && (this.current.state === RequestState.DELAY_PAY || this.current.state === RequestState.PAID || this.current?.state === RequestState.USED);
    if(this.current.subState === RequestSubState.REFUSED_IN || (this.current.subState === RequestSubState.REFUSED_OUT && refused)) {
      return false;
    }
    const isValidUsageCount = this.current?.usageCount <= this.current.document?.usageCount;
    const isNotExceedUsage = !(this.current?.usageCount >= this.current.document?.usageCount && this.current.isUsage);
    if(hasPermissionAndValidState && isValidUsageCount && isNotExceedUsage) {
      if(this.current.subState === RequestSubState.CHECKED_IN  && !this.current.document.multiUsage) {
        return false;
      }
      const eventOfPayment = this.current.events.length;
      return this.current.actualManualConfirmRounds <= eventOfPayment;
    }
    return false;
  }

  printSingleDocument(title: string, image: string) {
    const data: PrintSingleDocument = {
      title: this.lang.transform(title),
      date: format(new Date(), 'dd/MM/yyyy HH:mm'),
      id: this.current.id,
      img: image
    };
    this.print.print<PrintSingleDocument>(DocsPrintType.SINGLE_DOCUMENT, data);
  }

  openDocumentInWindow(file: string) {
    this.selectedDocument = file;
  }

  closePreview(): void {
    this.selectedDocument = null;
  }

  canInternalReference() {
    return this.api.userRole.isAdmin || (this.api.userRole.isWorker && this.seniorityLevel === 3 && !this.selectMode && !this.current.isExtension && (this.current.state === RequestState.PAID_NOT_CONFIRMED || this.current.state === RequestState.DELAY_PAY_NOT_CONFIRMED || this.current.state === RequestState.PAID || this.current.state === RequestState.PENDING || this.current.state === RequestState.DELAY_PAY)) && this.current.state !== RequestState.PENDING;
  }

  preparePrintVisa() {
    const data: any = [];
    if(this.current?.operationId) {
      data.push([this.lang.transform('document.type.DYN.'), this.lang.transform(this.current.operationId)]);
    }
    if(this.current?.usageAfter && (documentTypeIsAnyVisa(this.current.operationId) || documentTypeIsAnyExtension(this.current.operationId))) {
      data.push([this.lang.transform('form.usageAfter'), format(this.current.usageAfter, 'dd/MM/yyyy HH:mm')]);
    }
    if(this.current?.usageUntil && (documentTypeIsAnyVisa(this.current.operationId) || documentTypeIsAnyExtension(this.current.operationId))) {
      data.push([this.lang.transform('form.usageUntil'), format(this.current.usageUntil, 'dd/MM/yyyy HH:mm')]);
    }
    if(this.current?.localUsageUntil  && (documentTypeIsAnyVisa(this.current.operationId) || documentTypeIsAnyExtension(this.current.operationId))) {
      data.push([this.lang.transform('form.localUsageUntil'), format(this.current.localUsageUntil, 'dd/MM/yyyy')]);
    }
    if(this.current?.timeslot) {
      data.push([this.lang.transform('form.timeslot'), format(this.current.timeslot, 'dd/MM/yyyy HH:mm')]);
    }
    if(this.current?.amountCents) {
      data.push([this.lang.transform('form.amount'), this.getAmount(this.current.currency as any, this.current.amountCents)]);
    }
    if(this.current?.amountCents) {
      data.push([this.lang.transform('form.paymentType'), this.lang.transform(this.current.externalId ? 'payment.type.online' : 'payment.type.offline')]);
    }
    if(this.current?.state || this.current?.state === 0) {
      data.push([this.lang.transform('request.state.DYN.'), this.request.getStatusTheme(this.current).state]);
    }
    if(this.current?.batchId) {
      data.push([this.lang.transform('BatchId'), this.current.batchId]);
    }
    if(this.referencePaymentOnarrival) {
      data.push([this.lang.transform('paymentReference.ask'), this.referencePaymentOnarrival]);
    }

    if(this.current.metadata?.Urgent) {
      data.push([this.lang.transform('global.urgent'), this.current.metadata?.Urgent]);
    }
    if(this.current.metadata?.buyingOption && this.current.metadata?.buyingOption !== '{}' && this.current.metadata?.buyingOption !== 'Embassy fee') {
      data.push(['Buying Option', this.lang.transform('document.' + this.current.metadata.buyingOption)]);
    }
    if(this.current.metadata?.Documents?.PurposeOfVisit) {
      data.push([this.lang.transform('form.purposeOfVisit'), this.lang.transform('DYN.' + this.current.metadata.Documents.PurposeOfVisit)]);
    }
    const generalDataGroup: DataGroup = {
      subtitle: this.lang.transform('application.data'),
      data: data
    };
    if(data.length > 0) {
      this.printVisaApplication = [...this.printVisaApplication, generalDataGroup];
    }
  }

  preparePrintPersonalData() {
    const personalDataPrint: any = [];
    if(this.current.metadata?.FirstName || this.current.metadata?.firstName) {
      personalDataPrint.push([this.lang.transform('form.firstName'), this.current.metadata.FirstName || this.current.metadata.firstName]);
    }
    if(this.current.metadata?.LastName || this.current.metadata.lastName) {
      personalDataPrint.push([this.lang.transform('form.lastName'), this.current.metadata.LastName || this.current.metadata.lastName]);
    }
    if(hasValue(this.current.metadata?.BirthDay, 'date')) {
      personalDataPrint.push([this.lang.transform('form.birthDate'), format(new Date(+this.current.metadata!.BirthDay), 'dd/MM/yyyy')]); // Should always be int but some old errors
    }
    if(this.current.metadata?.PassportNumber) {
      personalDataPrint.push([this.lang.transform('form.passportNumber'), this.current.metadata.PassportNumber]);
    }
    if(hasValue(this.current.metadata?.DateOfIssue, 'date')) {
      personalDataPrint.push([this.lang.transform('form.passportNumber.dateOfIssue'), format(+this.current.metadata.DateOfIssue, 'dd/MM/yyyy HH:mm')]); // Should always be int but some old errors
    }
    if(hasValue(this.current.metadata?.DateOfExpiry, 'date')) {
      personalDataPrint.push([this.lang.transform('form.passportNumber.dateOfExpiry'), format(+this.current.metadata.DateOfExpiry, 'dd/MM/yyyy HH:mm')]); // Should always be int but some old errors
    }
    if(this.current.metadata?.PlaceofIssue) {
      personalDataPrint.push([this.lang.transform('form.passportNumber.placeOfIssue'), this.current.metadata.PlaceofIssue]);
    }
    if(this.current.metadata?.PlaceOfBirth) {
      personalDataPrint.push([this.lang.transform('form.placeOfBirth'), this.current.metadata.PlaceOfBirth]);
    }
    if(this.current.metadata?.Gender) {
      personalDataPrint.push([this.lang.transform('form.gender'), this.lang.transform('applicant.gender.' + this.current.metadata.Gender)]);
    }
    if(this.current.metadata?.MaritalStatus) {
      personalDataPrint.push([this.lang.transform('form.maritalStatus'), this.lang.transform('marital.status.' + this.current.metadata.MaritalStatus.toLowerCase())]);
    }
    if(this.current.metadata?.Occupation) {
      personalDataPrint.push([this.lang.transform('form.occupation'), this.current.metadata.Occupation]);
    }
    if(this.current.metadata?.Nationality) {
      personalDataPrint.push([this.lang.transform('form.nationality'), this.lang.transform('DYN.' + this.current.metadata.Nationality)]);
    }
    if(this.current.metadata?.idCard) {
      personalDataPrint.push([this.lang.transform('idcard.number'), this.current.metadata.idCard]);
    }
    if(this.current.metadata?.BirthCity) {
      personalDataPrint.push([this.lang.transform('form.birthCity'), this.current.metadata.BirthCity]);
    }
    if(this.current.metadata?.BirthCountry) {
      personalDataPrint.push([this.lang.transform('form.birthCountry'), this.current.metadata.BirthCountry]);
    }
    if(this.current.metadata?.EyeColor) {
      personalDataPrint.push([this.lang.transform('form.eyeColor'), this.lang.transform((this.current.metadata.EyeColor).toUpperCase())]);
    }
    if(this.current.metadata?.HairColor) {
      personalDataPrint.push([this.lang.transform('form.hairColor'), this.lang.transform((this.current.metadata.HairColor).toUpperCase())]);
    }
    if(this.current.metadata?.Height) {
      personalDataPrint.push([this.lang.transform('form.height'), this.current.metadata.Height]);
    }
    if(this.current.metadata?.FatherFirstName) {
      personalDataPrint.push([this.lang.transform('form.fatherFirstName'), this.current.metadata.FatherFirstName]);
    }
    if(this.current.metadata?.FatherLastName) {
      personalDataPrint.push([this.lang.transform('form.fatherLastName'), this.current.metadata.FatherLastName]);
    }
    if(this.current.metadata?.MotherFirstName) {
      personalDataPrint.push([this.lang.transform('form.motherFirstName'), this.current.metadata.MotherFirstName]);
    }
    if(this.current.metadata?.MotherLastName) {
      personalDataPrint.push([this.lang.transform('form.motherLastName'), this.current.metadata.MotherLastName]);
    }
    const personalDataGroup: DataGroup = {
      subtitle: this.lang.transform('personal.data'),
      data: personalDataPrint
    };

    if(personalDataPrint.length > 0) {
      this.printVisaApplication = [...this.printVisaApplication, personalDataGroup];
    }
  }

  prepareContactDataPrint() {
    const contactDataPrint: any = [];
    if(this.current.metadata?.Email || this.current.metadata?.email) {
      contactDataPrint.push([this.lang.transform('form.email'), this.current.metadata.Email || this.current.metadata.email]);
    }
    if(this.current.metadata?.Phone || this.current.metadata?.phone) {
      contactDataPrint.push([this.lang.transform('form.phone'), this.current.metadata.Phone || this.current.metadata.phone]);
    }
    if(this.current.metadata?.AddressZimbabwe) {
      contactDataPrint.push([this.lang.transform('form.addressZimbabwe'), this.current.metadata.AddressZimbabwe]);
    }
    if(this.current.metadata?.HomeAddress) {
      contactDataPrint.push([this.lang.transform('form.residenceAdress'), this.current.metadata.HomeAddress]);
    }
    if(this.current.metadata?.HostName) {
      contactDataPrint.push([this.lang.transform('form.hostName'), this.current.metadata.HostName]);
    }
    const contactDataGroup: DataGroup = {
      subtitle: this.lang.transform('contact.data'),
      data: contactDataPrint
    };
    if(contactDataPrint.length > 0) {
      this.printVisaApplication= [...this.printVisaApplication, contactDataGroup];
    }

  }

  preparePrintDiversVisa() {
    const diverseDataPrint: any = [];
    if(hasValue(this.current.metadata?.ArrivalDate, 'date')) {
      diverseDataPrint.push([this.lang.transform('form.arrivalDate'), format(+this.current.metadata.ArrivalDate, 'dd/MM/yyyy HH:mm')]); // Should always be int but some old errors
    }
    if(hasValue(this.current.metadata?.DepartureDate, 'date')) {
      diverseDataPrint.push([this.lang.transform('form.departureDate'), format(+this.current.metadata.DepartureDate, 'dd/MM/yyyy HH:mm')]); // Should always be int but some old errors
    }
    if(this.current.metadata?.ReferencePreviousVisa) {
      diverseDataPrint.push([this.lang.transform('form.referencePreviousVisa'), this.current.metadata.ReferencePreviousVisa]);
    }
    if(this.current.metadata?.PreviousConvictionsZim) {
      diverseDataPrint.push([this.lang.transform('form.previousConvictionsZim'), this.current.metadata.PreviousConvictionsZim]);
    }
    if(this.current.metadata?.PreviousConvictionsHome) {
      diverseDataPrint.push([this.lang.transform('form.previousConvictionsHome'), this.current.metadata.PreviousConvictionsHome]);
    }
    if(this.current.metadata?.PurposeOfVisit) {
      diverseDataPrint.push([this.lang.transform('form.purposeOfVisit'), this.current.metadata.PurposeOfVisit]);
    }
    if(this.current?.createdAt) {
      diverseDataPrint.push([this.lang.transform('date.creation'), format(this.current.createdAt, 'dd/MM/yyyy HH:mm')]);
    }
    if(this.current?.externalId) {
      diverseDataPrint.push([this.lang.transform('form.externalId'), this.current.externalId]);
    }
    if(this.createdPlace) {
      diverseDataPrint.push([this.lang.transform('form.created_place'), this.createdPlace.longName + ' [' + this.createdPlace.id + ']']);
    }
    if(this.placeConsumed) {
      diverseDataPrint.push([this.lang.transform('form.consumed_place'), this.placeConsumed.longName]);
    }
    if(this.current.metadata?.worker) {
      diverseDataPrint.push([this.lang.transform('form.userCreator'), this.sync.userDisplay(this.current.metadata.worker) +' #'+this.current.metadata.worker]);
    }
    if(this.current?.refunded_by_user__id) {
      diverseDataPrint.push([this.lang.transform('form.userRefund'), this.sync.userDisplay(this.current.refunded_by_user__id) +' #'+this.current.refunded_by_user__id]);
    }
    if(this.current?.used_by_user__id) {
      diverseDataPrint.push([this.lang.transform('form.userConsumed'), this.sync.userDisplay(this.current.used_by_user__id) +' #'+this.current.used_by_user__id]);
    }
    if(this.current.metadata?.FundsAvailable && this.current.metadata?.FundsAvailableCurrency) {
      const funds = this.current.metadata.FundsAvailable + ' ' + this.current.metadata.FundsAvailableCurrency + (this.current.metadata.FundsAvailableCurrency !== 'USD' ? (' ' + '(' + this.request.convertCurrency(this.current.metadata?.FundsAvailableCurrency, this.current.metadata?.FundsAvailable, 'USD')?.amount + ' ' + this.request.convertCurrency(this.current.metadata.FundsAvailableCurrency, this.current.metadata.FundsAvailable, 'USD')?.currency +')') : '');
      diverseDataPrint.push([this.lang.transform('FundsAvailable'), funds]);
    }
    if(this.current.metadata?.Documents?.RequestReason) {
      diverseDataPrint.push([this.lang.transform('RequestReason'), this.lang.transform('DYN.' + this.current.metadata.Documents.RequestReason)]);
    }
    const diverseDataGroup = {
      subtitle: this.lang.transform('divers.data.DYN.'),
      data: diverseDataPrint
    };
    if(diverseDataPrint.length > 0) {
      this.printVisaApplication = [...this.printVisaApplication, diverseDataGroup];
    }
  }

  preparePrintNextOfKin() {
    if(this.current.metadata.nextOfKin) {
      const nextOfKinData: any = [];
      const nextOfKin = this.JSONparse(this.current.metadata.NextOfKin);
      if(nextOfKin?.firstname) {
        nextOfKinData.push([this.lang.transform('form.firstName'), nextOfKin.firstname]);
      }
      if(nextOfKin?.lastname) {
        nextOfKinData.push([this.lang.transform('form.lastName'), nextOfKin.lastname]);
      }
      if(nextOfKin?.phone) {
        nextOfKinData.push([this.lang.transform('form.phone'), nextOfKin.phone]);
      }
      if(nextOfKin?.email) {
        nextOfKinData.push([this.lang.transform('form.email'), nextOfKin.email]);
      }
      const nextOfKinGroup = {
        subtitle: this.lang.transform('nextOfKin.data'),
        data: nextOfKinData
      };
      if(nextOfKinData.length > 0) {
        this.printVisaApplication = [...this.printVisaApplication, nextOfKinGroup];
      }
    }
  }

  preparePrintSpouse() {
    const spouseDataPrint: any = [];
    if(this.current.metadata?.SpouseFullName) {
      spouseDataPrint.push([this.lang.transform('form.spouseFullName'), this.current.metadata.SpouseFullName]);
    }
    if(this.current.metadata?.SpousePassportNumber) {
      spouseDataPrint.push([this.lang.transform('form.spousePassportNumber'), this.current.metadata.SpousePassportNumber]);
    }
    if(this.current.metadata?.SpouseBirthDay !== undefined && this.current.metadata?.SpouseBirthDay !== null && this.current.metadata?.SpouseBirthDay !== '') {
      spouseDataPrint.push([this.lang.transform('form.spouse.birthDay'), format(+this.current.metadata.SpouseBirthDay, 'dd/MM/yyyy HH:mm')]); // Should always be int but some old errors
    }
    if(this.current.metadata?.SpousePlaceOfBirth) {
      spouseDataPrint.push([this.lang.transform('form.spousePlaceOfBirth'), this.current.metadata.SpousePlaceOfBirth]);
    }
    const spouseDataGroup = {
      subtitle: this.lang.transform('spouse.data'),
      data: spouseDataPrint
    };
    if(spouseDataPrint.length > 0) {
      this.printVisaApplication = [...this.printVisaApplication, spouseDataGroup];
    }
  }

  preparePrintExtension() {
    const extensionDataPrint: any = [];
    if(this.current.metadata?.ExtensionReason) {
      extensionDataPrint.push([this.lang.transform('form.extensionReason'), this.current.metadata.ExtensionReason]);
    }
    if(this.current.metadata?.ExtensionDate) {
      extensionDataPrint.push([this.lang.transform('form.extensionDate'), format(+this.current.metadata.ExtensionDate, 'dd/MM/yyyy HH:mm')]); // Should always be int but some old errors
    }
    if(this.current.metadata?.AttestantAddress) {
      extensionDataPrint.push([this.lang.transform('attestantAddress'), this.current.metadata.AttestantAddress]);
    }
    if(this.current.metadata?.ReasonForExtension) {
      extensionDataPrint.push([this.lang.transform('reasonForExtention'), this.current.metadata.ReasonForExtension]);
    }
    if(this.current.metadata?.AttestantEmail) {
      extensionDataPrint.push([this.lang.transform('attestantEmail'), this.current.metadata.AttestantEmail]);
    }
    if(this.current.metadata?.AttestantID) {
      extensionDataPrint.push([this.lang.transform('attestantID'), this.current.metadata.AttestantID]);
    }
    if(this.current.metadata?.AttestantName) {
      extensionDataPrint.push([this.lang.transform('attestantName'), this.current.metadata.AttestantName]);
    }
    if(this.current.metadata?.AttestantPhone) {
      extensionDataPrint.push([this.lang.transform('attestantPhone'), this.current.metadata.AttestantPhone]);
    }
    if(this.current.metadata?.AttestantRelation) {
      extensionDataPrint.push([this.lang.transform('attestantRelation'), this.current.metadata.AttestantRelation]);
    }
    if(this.current.metadata?.DaysRequested) {
      extensionDataPrint.push([this.lang.transform('daysRequested'), this.current.metadata.DaysRequested]);
    }

    const extensionDataGroup = {
      subtitle: this.lang.transform('extension.data'),
      data: extensionDataPrint
    };
    if(extensionDataPrint.length > 0) {
      this.printVisaApplication = [...this.printVisaApplication, extensionDataGroup];
    }
  }

  isSameData(scannedData: string, visaData: string): boolean {
    const scannedDate = new Date(scannedData);
    const visaDate = new Date(visaData);
    if(!isNaN(scannedDate.getTime()) && !isNaN(visaDate.getTime())) {
      return format(scannedDate, 'yyyy/MM/dd') === format(visaDate, 'yyyy/MM/dd');
    } else {
      if(typeof scannedData === 'string') return scannedData?.trim()?.toLowerCase() === visaData?.trim()?.toLowerCase();
      return scannedData === visaData;
    }
  }

  /**
  * Determine if the scanned passport data differs from the application metadata.
  *
  * Comparison rules:
  * - Strings are compared case-insensitively after trimming.
  * - Dates can be supplied as YYMMDD strings or epoch numbers. They are normalized
  *   to the 'dd/MM/yyyy' format before comparison.
  * - Birth dates use past-date disambiguation when converting YYMMDD; expiry dates do not.
  */
  hasDifferences(): Difference[] {
    if(!this.scanDocument?.scanDatas || !this.current.metadata) {
      return [];
    }

    const scanFields = this.scanDocument.scanDatas.fields;
    const meta = this.current.metadata;

    // Case-insensitive, trimmed string normalization.
    const normalizeString = (value: any, lowercase: boolean): string => {
      const v = (value ?? '').toString().trim();
      return lowercase ? v.toLowerCase() : v.toUpperCase();
    };

    // Build field-by-field normalized comparisons.
    const comparisons = [
      {
        key: PassFields.FIRST_NAME,
        scanNorm: normalizeString(scanFields.firstName, false),
        metaNorm: normalizeString(meta.FirstName || meta.firstName, false)
      },
      {
        key: PassFields.LAST_NAME,
        scanNorm: normalizeString(scanFields.lastName, false),
        metaNorm: normalizeString(meta.LastName || meta.lastName, false)
      },
      {
        key: PassFields.SEX,
        scanNorm: normalizeString(scanFields.sex, true),
        metaNorm: normalizeString(meta.Gender, true)
      },
      ...(convertToEpoch(scanFields.birthDate) && meta.BirthDay ? [{
        key: PassFields.BIRTH_DAY,
        scanNorm: String(convertToEpoch(scanFields.birthDate, false, true)),
        metaNorm: String(convertToEpoch(convertToYYMMDD(meta.BirthDay), false, true))
      }] : []),
      ...(convertToEpoch(scanFields.expirationDate) && meta.DateOfExpiry ? [{
        key: PassFields.EXPIRATION_DATE,
        scanNorm: String(convertToEpoch(scanFields.expirationDate, false, false)),
        metaNorm: String(convertToEpoch(convertToYYMMDD(meta.DateOfExpiry), false, false))
      }] : []),
      {
        key: PassFields.NATIONALITY,
        scanNorm: normalizeString(scanFields.nationality, false),
        metaNorm: normalizeString(meta.Nationality, false)
      }
    ];
    // If any normalized value differs, there are differences.
    return comparisons.filter(c => c.scanNorm !== c.metaNorm);
  }

  getFormattedExternalIndexedData(): string {
    return this.current?.externalIndexedData.replace(/\|/g, ', ');
  }

  captureFingerprint() {
    if(electron.addon.hasSystemFingerprint()) if(electron.addon.scanFingerprint()) electron.beep();
  }

  openGate() {
    electron.step('go', true, [
      this.scanDocument?.scanDatas ? this.scanDocument.scanDatas.fields.firstName + ' ' + this.scanDocument.scanDatas.fields.lastName : 'person',
      this.scanDocument?.documentPhoto ? this.scanDocument.documentPhoto : '::0'
    ]);
  }

  closeGate() {
    electron.step('scan', true, []);
  }

  navToNotice(queryParams?: any) {
    if(!this.current.usageAfterValid) {
      this.loader.loading(true, {type: 'warn', message: this.lang.transform('error.paymentUntil.before', {dateAfter: format(this.current.usageAfter, 'dd/MM/yyyy HH:mm')} )});
    } else {
      this.nav.to('admin-request-notice/' + this.paymentId, undefined, {queryParams});
    }
  }

  getCategoriesElement(): string {
    if(!this.current?.watchlistsResponse?.matches.length) {
      return '';
    }
    return this.current?.watchlistsResponse?.matches.filter(match => match.watchlist.category).map(match => match.watchlist.category).join(', ');
  }

  handleClickLink(event: MouseEvent, url: string) {
    event.stopPropagation();
    window.open(url, '_blank');
  }

  preparePrintReceipt() {
    if(!this.current || !this.current.events) return;
    const adaptEvents = this.getAdaptEvents(this.current.events, this.current);
    const receiptEvents = this.filterReceiptEvents(adaptEvents, this.current);
    this.printReceiptData = receiptEvents.map(event => {
      const statusLabels = this.getLabelReceipt(event, this.current);
      return {
        referencePrint: event.consumeData?.PaymentReference || (JSON.parse(event.context).externalId !== undefined ? JSON.parse(event.context).externalId : this.current.externalId || '') || this.current.metadata.PaymentReference,
        datePrint: new Date(event.updatedOn),
        nameClient: (this.current.metadata?.FirstName || this.current.parent?.metadata?.FirstName || '') + ' ' + (this.current.metadata?.LastName || this.current.parent?.metadata?.LastName || ''),
        amount: event.consumeData?.PaymentIsNotDocument === 'Yes' && event.consumeData?.PaymentAmountCents ? event.consumeData?.PaymentAmountCents : this.current.amountCents,
        currency: event.consumeData?.PaymentCurrency || this.current.currency,
        agentId: event.consumeData ? event.actor_id : this.current.person_id,
        customerName: event.consumeData ? '': `${event.indexed.FirstName || ''} ${event.indexed.LastName || ''}`,
        typePayment: event.consumeData?.PaymentMode || this.current.metadata?.PaymentMode,
        onlinePayment: this.current.externalId && statusLabels !== 'overstay' ? 'online' : 'offline',
        placeId: event.place_id || this.currentPlace?.id,
        buyDocument: statusLabels,
        operation: event.consumeData?.Operation || event.indexed?.operation || PlatformEventType[event.type],
        idRequest: this.current.parent?.id || this.current.id,
        nationality: this.current.metadata?.Nationality || this.current.parent?.metadata?.Nationality,
        gender: this.current.metadata?.Gender || this.current.parent?.metadata?.Gender,
        HQReference: this.current.internalReference || this.current.parent?.internalReference,
        vendorName: this.api.userInfo.server.emailConfig.copyrightName,
        vendorAddress: this.api.userInfo.server.emailConfig.address,
        vendorEmail: this.api.userInfo.server.emailConfig.email,
        serialNumber: event.consumeData?.PlaceSerial,
        placePhone: this.currentPlace?.phoneNumbersCsv || '',
        current: this.current
      } as PrintReceiptData;
    });
  }

  getLabelReceipt(newEvent: PlatformEvent, current: RequestWithDuplicata) {
    if(!newEvent || !current || !current.events) return null;

    const operationId = this.current?.operationId || this.current.visaType.id;
    if(!this.current || !operationId) return null;

    const buyDocument = this.current.metadata?.BorderPass === 'Yes' ? getDocumentTypeIsBorderPass() : operationId;
    const isOverstay = (this.current as RequestWithDuplicata).localUsageUntilValid !== undefined ? this.request.isOverstayOut(this.current as RequestWithDuplicata) : false;
    const isTransit = this.request.isTransit(this.current);
    const receiptLabel = isOverstay && newEvent?.consumeData?.PaymentIsNotDocument === 'Yes' ? 'overstay' : isTransit ? 'Transit' : (buyDocument + '.title');

    return receiptLabel;
  }

  private isValidPaymentMode(event: PlatformEvent): boolean {
    return event.indexed?.PaymentMode !== undefined && event.indexed?.PaymentMode !== '-';
  }

  private filterEventsWithOperationAndValidPaymentMode(events: PlatformEvent[]): PlatformEvent[] {
    return events.filter(event => event.indexed?.Operation !== undefined && this.isValidPaymentMode(event));
  }

  private getAdaptEvents(events: PlatformEvent[], current: any): PlatformEvent[] {
    const filteredEvents = this.filterEventsWithOperationAndValidPaymentMode(events);
    if(current.externalId && !current.isExtension) {
      const onlinePaymentIndex = events.findIndex(event => event.type === PlatformEventType.PAYMENT_CREATED);
      const onlinePaymentEvent = onlinePaymentIndex >= 0 ? events[onlinePaymentIndex] : null;
      return onlinePaymentEvent ? [onlinePaymentEvent, ...filteredEvents] : filteredEvents;
    }

    if(current.isExtension && current.amountCents > 0) {
      return [events[0]];
    }

    return filteredEvents;
  }

  private filterReceiptEvents(events: PlatformEvent[], current: any): PlatformEvent[] {
    if(current.isExtension) {
      return events;
    }
    return events.filter(event => {
      if(event.consumeData) {
        return event.consumeData.PaymentReference !== undefined;
      }
      if(event.context && event.type !== PlatformEventType.PAYMENT_FINALIZED) {
        return JSON.parse(event.context).externalId !== undefined;
      }
      return event.type === PlatformEventType.PAYMENT_FINALIZED;
    });
  }

  preparePrintBorderPass() {
    const eventPayBorderPass = this.current.events?.find(event => event.consumeData && event.consumeData.Operation === OperationType.OUT && this.current.metadata.BorderPass === 'Yes');
    this.printBorderPassData = {
      borderPassNumber: this.current.metadata.BorderPassNumber,
      fullNames: this.current.metadata.FirstName + ' ' + this.current.metadata.LastName,
      dateOfBirth: this.current.metadata.BirthDay,
      residentialAddress: this.current.metadata.ResidentialAddress,
      issueDate: this.current.metadata.IssueDate,
      expiryDate: this.current.metadata.ExpiryDate,
      reason: this.current.metadata.Reason,
      authorizedCrossingPoints: this.current.metadata.AuthorizedCrossingPoints,
      place: eventPayBorderPass ? eventPayBorderPass.place?.longName : this.api.userPlace?.longName,
      officer: eventPayBorderPass ? eventPayBorderPass.actor_id : this.api.userInfo.id,
      qrCode: this.current.qrCode,
      borderPassPicture: this.current.metadata?.BorderPassPicture
    };
  }


  preparePrintDecisionLetter(){
    const isApproval = this.isDecisionLetterApproval();
    const isRefusal = this.isDecisionLetterRefusal();
    if(!isApproval && !isRefusal) {
      this.printDecisionLetterData = undefined;
      return;
    }

    const fullName = `${this.current?.metadata?.FirstName || ''} ${this.current?.metadata?.LastName || ''}`.trim();
    const refusalEvent = this.current?.events?.find(event => event.type === PlatformEventType.PAYMENT_REFUSED && (!this.current?.refusalReason || event.context?.includes(this.current.refusalReason))) || this.current?.events?.find(event => event.type === PlatformEventType.PAYMENT_REFUSED);
    const formatDecisionDate = (d: string) => format(parseISO(d), 'yyyy-MM-dd');
    const refusalDate = refusalEvent?.updatedOn ? formatDecisionDate(refusalEvent.updatedOn) : undefined;
    const approvalEvent = this.current?.events?.filter(event => event.type === PlatformEventType.PAYMENT_VALIDATED).sort((a, b) => b.updatedOn.localeCompare(a.updatedOn))[0];
    const approvalDate = approvalEvent?.updatedOn ? formatDecisionDate(approvalEvent.updatedOn) : undefined;

    const amountCents = this.current?.amountCents;
    const currency = this.current?.currency;
    const amountStr = amountCents !== null && amountCents !== undefined && currency ? this.getAmount(currency as any, amountCents) : undefined;

    this.printDecisionLetterData = {
      requestId: this.current?.id,
      applicationReference: this.current?.batchId,
      hqRef: this.current?.internalReference || undefined,
      isApproval,
      isRefusal,
      name: fullName,
      approvalDate: isApproval ? approvalDate : undefined,
      refusalDate: isRefusal ? refusalDate : undefined,
      invitingCompanyName: this.current?.metadata?.InvitingCompanyName,
      address: this.api.userInfo?.server?.emailConfig?.address,
      amount: amountStr,
      documentType: this.current?.document?.id ? this.lang.transform(this.current.document.id.indexOf('ext') > -1 ? 'decisionLetter.documentType.extension' : 'decisionLetter.documentType.application') : undefined,
      qrCode: this.current?.qrCode
    };
  }

  isDecisionLetterApproval(): boolean {
    return !this.offlineApplication && this.current?.state === RequestState.PAID && !this.environment.useGuichet && !isRequirePreapproval(this.current, this.api.env);
  }

  isDecisionLetterRefusal(): boolean {
    return !this.environment.useGuichet && !!this.current?.refusalReason && (this.current?.state === RequestState.EXPIRED || this.current?.state === RequestState.PENDING);
  }

  canPrintDecisionLetter(): boolean {
    return this.isDecisionLetterApproval() || this.isDecisionLetterRefusal();
  }

  prepareVisualDocuments() {
    const arrayDocuments: {nameDocument: string, document: any, title?: string, icon?: string, customClass?: string, previewDirect?: string, checkComparison?: boolean}[] = (this.current.metadata.Documents && !isEmptyObject(this.current.metadata.Documents)) ? Object.entries(this.current.metadata.Documents).map(([nameDocument, document]) => ({nameDocument, document})).filter(doc => isBase64(doc.document as string) || isPDF(doc.document as string)): [];
    if(arrayDocuments && arrayDocuments.length) {
      arrayDocuments.forEach(doc => {
        const {title, icon} = this.getDocTitleAndIcon(doc.nameDocument);
        doc.title = title;
        doc.icon = icon;
        if(doc.nameDocument === VisaFN.PASSPORT_PHOTO) {
          doc.customClass = 'doc doc-dk doc-previewDirect';
          doc.previewDirect = 'photo.current';
        }
      });
    }

    if(this.scanDocument?.documentPhoto && this.current.showComparison) {
      arrayDocuments.unshift({
        nameDocument: VisaFN.PASSPORT_SCAN,
        document: this.scanDocument.documentPhoto,
        title: 'photo.scanned',
        customClass: 'doc doc-dk doc-previewDirect',
        previewDirect: 'photo.scanned',
        checkComparison: true
      });
    }
    this.metadataDocuments = arrayDocuments;
    this.missingSchemaDocuments = this.getMissingSchemaDocuments();
  }

  isLocalUsageUntilError() {
    return this.current?.localUsageUntil && !this.current.localUsageUntilValid;
  }

  downgrade() {
    if(documentTypeIsVisaMultiple(this.current.operationId)) {
      const dialogInput: DialogFormInput[] = [
        {
          formCtrlName: 'downgradeType',
          type: 'select',
          label: this.lang.transform('downgrade.type.label'),
          validator: [Validators.required],
          selectOptions: [
            {name: this.lang.transform('zwevisa_double'), value: 'DOUBLE'},
            {name: this.lang.transform('zwevisa'), value: 'SINGLE'}
          ]
        }
      ];
      this.loader.loading(true, {
        type: 'question',
        message: 'ask.downgradeType',
        btnLabel: 'global.confirm',
        custom: {closeBtnLabel: 'global.cancel', icon: 'arrow-down'},
        dialogInput
      }).then((res: any) => {
        if(res?.downgradeType) {
          const selectedOption = dialogInput[0].selectOptions.find(opt => opt.value === res.downgradeType);
          const typeLabel = selectedOption ? selectedOption.name : res.downgradeType;
          this.loader.loading(true, {
            type: 'warn',
            btnLabel: 'global.yes',
            custom: {
              innerHtml: this.lang.transform('ask.downgrade.multiple', {type: typeLabel}),
              icon: 'circle-down'
            }
          }).then((done: boolean) => {
            if(done) {
              this.loader.loading(true);
              const docType = res.downgradeType === 'DOUBLE' ? getDocumentTypeIsVisaDouble() : getDocumentTypeIsVisa();
              this.api.updatePayment(this.current.id, undefined, undefined, undefined, undefined, undefined, undefined, docType).then(() => {
                this.loader.loading(true, {type: 'valid', message: 'done.downgrade'}).then(() => {
                  this.getPayment();
                });
              }).catch(() => {
                this.loader.loading(true, {type: 'error', message: 'error.downgrade'});
              });
            }
          });
        }
      });
    } else {
      this.loader.loading(true, {type: 'warn', message: 'ask.downgrade', btnLabel: 'global.yes', custom: {icon: 'circle-down'}}).then((done: boolean) => {
        if(done) {
          this.loader.loading(true);
          this.api.updatePayment(this.current.id, undefined, undefined, undefined, undefined, undefined, undefined, getDocumentTypeIsVisa()).then(() => {
            this.loader.loading(true, {type: 'valid', message: 'done.downgrade'}).then(() => {
              this.getPayment();
            });
          }).catch(() => {
            this.loader.loading(true, {type: 'error', message: 'error.downgrade'});
          });
        }
      });
    }
  }

  canPrintBorderPass() {
    return this.current.offlineParentMethodName && this.current.metadata.BorderPass === 'Yes' || (this.printBorderPassData && documentTypeIsExit(this.current.operationId) && this.current.subState === RequestSubState.CLOSED && this.current.events.find(event => event.consumeData && event.consumeData.Operation !== OperationType.REFUSEOUT  && event.consumeData.Operation !== OperationType.REFUSEIN) && (this.current.metadata.BorderPass && this.current.metadata.BorderPass === 'Yes'));
  }

  getWarningMessage(): string {
    const messages = [];
    const actionState =  this.request.getStatusTheme(this.current).actionState;
    const readyApplication = actionState === ActionState.READY_CHECKIN || actionState === ActionState.READY_CHECKOUT || actionState === ActionState.READY_CHECK;
    if(!this.current.usageUntilValid && readyApplication) {
      messages.push(this.lang.transform(this.isCatEasy ? 'outUsage.AB' : 'outUsage.C'));
    }
    if(!this.current.localUsageUntilValid && (actionState === ActionState.READY_ZWEEXIT || actionState === ActionState.READY_CHECKOUT)) {
      messages.push(this.lang.transform('application.overStay'));
      messages.push(this.lang.transform('expiredSinceTime', {days: this.diffDays, hours: this.diffHours}));
    }
    if(this.current?.watchlistsResponse?.matches?.length) {
      messages.push(this.lang.transform('watchlistFound'));
    }
    if(this.current?.apipnrResponse?.matches?.length && this.api.env.enableCrossCheckApiPNR) {
      messages.push(this.lang.transform('apipnrFound'));
    }
    return (this.current.state !== RequestState.PROPOSED) ? messages.join(' & ') : '';
  }

  changeDeportedMode(event: boolean) {
    this.deportedMode = event;
  }

  toggleShowComparison() {
    this.current.showComparison = !this.current.showComparison;
    if(this.current.showComparison) {
      const hasComparison = this.metadataDocuments.some(doc => doc.checkComparison);
      if(!hasComparison && this.scanDocument?.documentPhoto) {
        this.metadataDocuments.unshift({
          nameDocument: VisaFN.PASSPORT_SCAN,
          document: this.scanDocument.documentPhoto,
          title: 'photo.scanned',
          customClass: 'doc doc-dk doc-previewDirect',
          previewDirect: 'photo.scanned',
          checkComparison: true
        });
      }
    } else {
      this.metadataDocuments = this.metadataDocuments.filter(doc => !doc.checkComparison);
    }
  }

  preparePrintNotices() {
    const notices = this.current?.events?.filter(event => event.consumeData?.Documents?.some((document: any) => document.Type === NoticeType.RESTRICTION || document.Type === NoticeType.REPORTING || document.Type === NoticeType.REFUSAL)) || [];
    if(!notices.length) {
      return;
    }
    this.existingNotices = notices;
  }

  printNotices() {
    const longName = this.current.metadata?.FirstName || this.current.metadata?.LastName ? (this.current.metadata?.FirstName || '') + (this.current.metadata?.LastName ? ' ' + this.current.metadata?.LastName : '') : '';

    const noticePrintAction = (event: PlatformEvent) => {
      const documentsConsumeData = event.consumeData.Documents[0];
      const restrictionFields = documentsConsumeData?.RestrictionFields;
      const reportingFields = documentsConsumeData?.ReportingFields;
      const refusalFields = documentsConsumeData?.RefusalFields;
      switch(documentsConsumeData.Type) {
      case NoticeType.REPORTING:
        const reportingForm = this.formBuilder.group({
          hqReference: [this.current.internalReference || ''],
          stationReference: [event.place.longName +' ['+ event.place.id +']' || ''],
          purpose: [reportingFields?.Purpose || ''],
          fullNames: [longName],
          host: [reportingFields?.Host || ''],
          phone: [reportingFields?.Phone || ''],
          hostPhone: [reportingFields?.HostPhone || ''],
          addressZimbabwe: [reportingFields?.AddressZimbabwe || ''],
          email: [reportingFields?.Email],
          address: [reportingFields?.Address || ''],
          periodFrom: [reportingFields?.PeriodFrom || ''],
          periodTo: [reportingFields?.PeriodTo || ''],
          officer: [event.actor_id],
          reportAt: [reportingFields?.ReportingPost || ''],
          reportOn: [reportingFields?.ReportOn ? reportingFields?.ReportOn : ''],
          reportInterval: [reportingFields?.ReportAtIntervalDays || '']
        });
        const reportingData: PrintNoticeData = {
          form: reportingForm,
          qrCode: this.current.qrCode
        };
        this.print.print<PrintNoticeData>(NoticeType.REPORTING, reportingData);
        break;
      case NoticeType.RESTRICTION:
        const restrictionForm = this.formBuilder.group({
          hqReference: [this.current.internalReference || ''],
          stationReference: [event.place.longName +' ['+ event.place.id +']' || ''],
          fullNames: [longName],
          reportLocation: [restrictionFields?.ReportingPost || ''],
          daysUntilReport: [restrictionFields?.GracePeriodDays || ''],
          otherMissingDocument: [restrictionFields?.DocumentToProduceOther || ''],
          residentialAddress: [restrictionFields?.ResidentialAddress || ''],
          businessAddress: [restrictionFields?.BusinessAddress || ''],
          phone: [restrictionFields?.Phone || ''],
          email: [restrictionFields?.Email || ''],
          officer: [event.actor_id]
        });
        const restrictionData: PrintNoticeRestrictionData = {
          form: restrictionForm,
          qrCode: this.current.qrCode,
          documents: documentsConsumeData.RestrictionFields.DocumentToProduce
        };
        this.print.print<PrintNoticeData>(NoticeType.RESTRICTION, restrictionData);
        break;
      case NoticeType.REFUSAL:
        const refusalForm = this.formBuilder.group({
          fullNames: [longName],
          reportLocation: [event.place.longName +' ['+ event.place.id +']' || ''],
          paragraph: [refusalFields?.Paragraph || ''],
          reason: [refusalFields?.Reason || ''],
          dateOfRefusal: [format(event.updatedOn, 'yyyy-MM-dd')],
          place: [event.place.longName +' ['+ event.place.id +']' || ''],
          officer: [event.actor_id],
          operationComments: [event?.consumeData?.OperationComments || '']
        });
        const refusalData: PrintNoticeData = {
          form: refusalForm,
          qrCode: this.current.qrCode
        };
        this.print.print<PrintNoticeData>(NoticeType.REFUSAL, refusalData);
      }
    };

    if(this.existingNotices?.length === 1) {
      this.loader.loading(true, {
        type: 'question',
        message: this.lang.transform('ask.noticePrint', {date: format(this.existingNotices[0].updatedOn, 'dd/MM/yyyy')}),
        btnLabel: 'global.yes',
        custom: {icon: 'print'}
      }).then((res: boolean) => {
        if(res) {
          noticePrintAction(this.existingNotices[0]);
        }
      });
    } else if(this.existingNotices?.length > 1) {
      const dialogInput = [
        {
          formCtrlName: 'selectedNotice',
          type: 'select',
          label: 'select.notice',
          selectOptions: this.existingNotices.map((notice: PlatformEvent, index: number) => ({
            name: `${format(notice.updatedOn, 'dd/MM/yyyy')} - ${this.lang.transform(`notice.${notice.consumeData.Documents[0].Type}`)}`,
            value: index
          })),
          validator: [Validators.required]
        }
      ] as DialogFormInput[];
      this.loader.loading(true, {
        type: 'question',
        message: 'ask.selectNotice',
        btnLabel: 'global.confirm',
        custom: {
          closeBtnLabel: 'global.cancel',
          icon: 'print'
        },
        dialogInput
      }).then((res: any) => {
        if(res?.selectedNotice) {
          const selectedNotice = this.existingNotices[res.selectedNotice];
          noticePrintAction(selectedNotice);
        }
      });
    }
  }

  canMarkAsClosed(): boolean {
    if(!this.current || this.offlineApplication) return false;
    if(!this.current.allProcessed) return false;
    if(this.current.subState === RequestSubState.CLOSED) return false;
    if(![RequestState.PAID, RequestState.DELAY_PAY, RequestState.USED].includes(this.current.state)) return false;
    if(!this.hasUiPerm(UiPermission.SHOW_CLOSE_APP_BTN)) return false;
    return true;
  }

  markAsClosed() {
    return this.loader.loading(true, {type: 'warn', message: 'ask.closeApplication', btnLabel: 'global.confirm'}).then((r: boolean) => {
      if(r) {
        return this.fingerprint.supervision('closeApplication').then(() => {
          this.loader.loading(true);
          return this.api.changePayment(this.current.id, RequestState.USED, RequestSubState.CLOSED).then(() => this.loader.loading(true, {type: 'question', message: 'done.closeApplication', btnLabel: 'yes'}).then((done) => {
            if(done) {
              if((this.request.getStatusTheme(this.current).actionState === ActionState.READY_CHECKIN || this.request.getStatusTheme(this.current).actionState === ActionState.READY_CHECK) && !documentTypeIsExit(this.current.operationId)) {
                this.scanDocument.scanned = true;
                this.scanDocument.scanDatas = {fields: {
                  nationality: this.current.metadata.Nationality || '',
                  lastName: this.current.metadata.LastName || '',
                  firstName: this.current.metadata.FirstName || '',
                  sex: this.current.metadata.Gender || '',
                  documentNumber: this.current.metadata.PassportNumber || '',
                  expirationDate: this.current.metadata.DateOfExpiry || '',
                  birthDate: format(this.current.metadata.BirthDay, 'yyMMdd') ?? ''
                }} as any;
                return this.cart.startApplication(true);
              } else {
                const prefillDatas = {
                  firstName: this.current.metadata.FirstName || '',
                  lastName: this.current.metadata.LastName || '',
                  birthDay: this.current.metadata.BirthDay ?? '',
                  passportType: this.current.metadata.PassportType || '',
                  gender: this.current.metadata.Gender || '',
                  nationality: this.current.metadata.Nationality || '',
                  passportNr: this.current.metadata.PassportNumber || ''
                };
                return this.nav.to('admin-request-create', undefined, {queryParams: {fromRoute: ('admin-request-select/' + this.paymentId), prefill: JSON.stringify(prefillDatas)}});
              }
            } else {
              return this.getPayment();
            }
          })).catch(() => {
            this.loader.loading(true, {type: 'error', message: 'error.closeApplication'});
          });
        });
      }
    });
  }

  revertConsume(event: PlatformEvent) {
    const dialogReasonInput = [{
      formCtrlName: 'revertReason',
      type: 'textarea',
      label: 'revert.consume',
      maxLength: 200
    }] as DialogFormInput[];
    this.loader.loading(true, {type: 'warn', message: 'ask.revertConsume', btnLabel: 'global.yes', dialogInput: dialogReasonInput, custom: {icon: 'undo'}}).then((done: any) => {
      if(done) {
        this.loader.loading(true);
        return this.api.voidConsumePayment(this.current.id, event.id, done.revertReason).then(() => this.loader.loading(true, {type: 'valid', message: 'done.revertConsume'}).then(() => {
          this.storage.removeFromStorage(Store.PAYMENT_STORE, this.current.id).then(() => {
            setTimeout(() => this.getPayment(true));
          });
        })).catch(() => this.loader.loading(true, {type: 'error', message: 'error.revertConsume'}));
      }
    });
  }

  isLatestUpdatedEvent(event: PlatformEvent): boolean {
    const listOfUpdates = this.current.events.filter(e => e.type === PlatformEventType.PAYMENT_SUSPEND_CHANGE || (e.type === PlatformEventType.PAYMENT_UPDATED && !e.place_id));
    const sorted = listOfUpdates.sort((a, b) => new Date(b.updatedOn).getTime() - new Date(a.updatedOn).getTime());
    return sorted[0].id === event.id && this.current.state !== RequestState.PENDING;
  }

  internalReference(edit = false) {
    const HQ_REFERENCE_PATTERN = /^\d+_\d{4}$/;
    const dialogInput = [{
      formCtrlName: 'internalReference',
      type: 'textarea',
      value: this.current.internalReference || '',
      label: 'internalReference.desc',
      maxLength: 40,
      validator: [Validators.required, Validators.pattern(HQ_REFERENCE_PATTERN)]
    }] as DialogFormInput[];
    this.loader.loading(true, {type: 'info', message: this.current.internalReference ? 'internalReference.ask.edit' : 'internalReference.ask.create', dialogInput}).then((res: any) => {
      if(res?.internalReference) {
        res.internalReference = formatInternalReference(res.internalReference);
        if(!HQ_REFERENCE_PATTERN.test(res.internalReference)) {
          this.loader.loading(true, {type: 'warn', message: 'internalReference.badPattern'});
          return;
        }
        return this.api.updatePayment(this.current.id, undefined, undefined, undefined, undefined, undefined, res.internalReference).then(() => {
          this.getPayment();
          this.loader.loading(true, {type: 'valid', message: edit ? 'internalReference.done.edit' : 'internalReference.done.create'});
        }).catch(() => {
          this.loader.loading(true, {type: 'error', message: 'error.internalReference'});
        });
      }
    });
  }

  private checkScannedGender() {
    if(this.current.state !== RequestState.USED && this.scanDocument?.scanDatas && this.current.metadata.Gender && this.current.metadata.Gender === Gender.OTHER) {
      const dialogInput = [{
        formCtrlName: 'gender',
        type: 'select',
        label: 'form.gender',
        selectOptions: [
          {name: 'male', value: Gender.MALE},
          {name: 'female', value: Gender.FEMALE}
        ]
      }] as DialogFormInput[];
      setTimeout(() => {
        this.loader.loading(true, {type: 'info', message: 'changeGender.ask', dialogInput, btnLabel: 'global.confirm', custom: {icon: 'venus-mars'}}).then((res: any) => {
          if(res?.gender) {
            const serializedDatas = JSON.stringify({[VisaFN.GENDER]: res.gender});
            this.loader.loading(true);
            this.api.updatePayment(this.current.id,
              undefined, undefined, serializedDatas, undefined,
              undefined, undefined, undefined, undefined, undefined).then(() => {
              this.getPayment();
              this.loader.loading(false);
            }).catch(() => {
              this.loader.loading(true, {type: 'error', message: 'global.error'});
            });
          }
        });
      }, 500);
    }
  }

  getPrintEvents(): PlatformEvent[] {
    return this.current?.events?.filter(event => event.type === PlatformEventType.PAYMENT_PRINTED);
  }

  openInternalReference() {
    if(this.current?.internalReference) window.open(this.api.env.referenceUri + this.current.internalReference + '&access_token=' + this.api.jwt, '_new');
  }

  openWatchListWindow(match: WatchlistMatch) {
    match?.item?.link && window.open(match?.item?.link, '_new');
  }

  private reloadOnDraft(current: RequestWithDuplicata) {
    this.checkDraftTimeout = setTimeout(() => {
      if(current.state === RequestState.PROPOSED) this.getPayment(false, current.id);
      clearTimeout(this.checkDraftTimeout);
    }, 5000);
  }

  updateForHKG() {
    this.loader.loading(true, {type: 'info', message: 'ask.updateForHKG', btnLabel: 'global.yes'}).then((res: any) => {
      if(res) {
        this.loader.loading(true);
        const fieldsToUpdate = {[PassFields.NATIONALITY]: 'HKG'};
        return this.scanDocument.transferFromPassportData(this.current.id, fieldsToUpdate, true).then(() => {
          this.current.allProcessed = false;
          this.getPayment();
        }).catch(() => {
          this.loader.loading(true, {type: 'error', message: 'error.updateForHKG'});
        });
      }
    });
  }

  openDialogEditPassport() {
    this.fingerprint.supervision('supervision.updateManuallyPassport').then(() => {
      const data = {
        [PassFields.FIRST_NAME]: this.current.metadata?.FirstName || '',
        [PassFields.LAST_NAME]: this.current.metadata?.LastName || '',
        [PassFields.BIRTH_DAY]: this.current.metadata?.BirthDay ?? '',
        [PassFields.DOCUMENT_NUMBER]: this.current.metadata?.PassportNumber || '',
        [PassFields.SEX]: this.current.metadata?.Gender || '',
        [PassFields.NATIONALITY]: this.current.metadata?.Nationality || '',
        [PassFields.EXPIRATION_DATE]: this.current.metadata?.DateOfExpiry ?? ''
      };
      return this.dialog.openDialog(DialogEditPassportComponent, 'md', data).then((updatedData: PassFieldsData) => {
        if(!isEmptyObject(updatedData)) {
          return this.loader.loading(true, {type: 'question', message: 'ask.updateManuallyPassport', btnLabel: 'global.yes'}).then((res: boolean) => {
            if(res) {
              this.loader.loading(true);
              if(updatedData.birthDate) {
                updatedData.birthDate = convertToYYMMDD(new Date(updatedData.birthDate));
              }
              if(updatedData.expirationDate) {
                updatedData.expirationDate = convertToYYMMDD(new Date(updatedData.expirationDate));
              }
              return this.scanDocument.transferFromPassportData(this.current.id, updatedData, true).then(() => {
                this.current.allProcessed = false;
                this.getPayment();
              }).catch(() => {
                this.loader.loading(true, {type: 'error', message: 'error.updatePassport'});
              });
            }
          });
        }
      });
    });
  }

  transferOtherState() {
    this.loader.loading(true, {type: 'info', message: this.lang.transform('ask.transferOtherState', {transfertMode: this.lang.transform(this.scanDocument?.consumeMode === ConsumeMode.ENTRY ? 'payment_status.DYN.1' : 'payment_status.DYN.9.exit')} ), btnLabel: 'global.yes'}).then((res: any) => {
      if(res) {
        const forcedTransfert = this.scanDocument?.consumeMode === ConsumeMode.ENTRY ? OperationType.IN : OperationType.OUT;
        this.consumePayment(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, forcedTransfert);
      }
    });
  }

  detectConsumeMode() {
    const isEntry = this.scanDocument?.consumeMode === ConsumeMode.ENTRY;
    const isExit = this.scanDocument?.consumeMode === ConsumeMode.EXIT;
    const actionState = this.request.getStatusTheme(this.current).actionState;
    const isReadyCheckoutOrZweeExit = actionState === ActionState.READY_CHECKOUT || actionState === ActionState.READY_ZWEEXIT;
    const isReadyCheckinOrCheck = actionState === ActionState.READY_CHECKIN || actionState === ActionState.READY_CHECK;
    const hasUsageLeft = this.current.checkoutIsNext ? this.current.usageCount < this.current.document?.usageCount : true;
    const isNotZweOperation = !documentTypeIsExit(this.current.operationId) && !documentTypeIsEntry(this.current.operationId);
    this.otherStateAction = ((isEntry && isReadyCheckoutOrZweeExit) || (isExit && isReadyCheckinOrCheck)) && hasUsageLeft && isNotZweOperation && !this.current.isExtension;
  }

  openBatchView(id: string) {
    this.toggleSelectMode(false);
    this.metadataDocuments = [];
    this.isSyncing = false;
    this.isCatEasy = false;
    this.qr.deleteCurrentQrData();
    this.printVisaApplication = [];
    this.payment.current$.next(undefined);
    this.nav.to('admin-request-select/' + id);
  }

  loadFullMetadata() {
    this.getPayment(true, this.paymentId, true);
    this.loadDocumentsClicked = true;
  }

  hasMetadataDocuments(): boolean {
    return this.metadataDocuments?.filter(doc => doc.nameDocument !== VisaFN.PASSPORT_SCAN).length > 0;
  }

  private getPayment(loader = false, id = this.paymentId, fullMetadata?: boolean) {
    if(this.offlineApplication) return;
    this.payment.getPayment(id, loader, {
      history: true,
      watchlist: this.api.userRole.isWorker,
      apipnr: this.api.userRole.isWorker,
      inbound: this.hasUiPerm(UiPermission.CAN_LOAD_INBOUND),
      fullMetadata: fullMetadata || this.hasUiPerm(UiPermission.CAN_LOAD_FULLMETADATA)
    }, true);
  }

  private async setOfflineCurrent(req: RequestWithDuplicata, queueId: string) {
    const isExtension = documentTypeIsVisaExtAB(req.visaType.id) || documentTypeIsVisaExtC(req.visaType.id);
    const extensionPrice = isExtension ? Number(await this.request.getExtensionPrice(req, true, true)) * 100 : 0;
    const document = this.api.userInfo.server.paymentRequests.find(d => d.id === (req.visaType.id as DocumentType));
    const borderPassPrice = req.metadata?.BorderPass === 'Yes' ? eval(document.amountCentsDyn)({BorderPass: req.metadata?.BorderPass}, this.api.userPlace) : 0;

    this.current = {
      state: isExtension ? RequestState.DELAY_PAY_NOT_CONFIRMED : req.visaType.amountCents > 0 || borderPassPrice ? RequestState.DELAY_PAY : RequestState.PAID,
      subState: RequestSubState.NONE,
      apipnrResponse: {matches: []}, duplicatas: [], fetchedAt: '', watchlistsResponse: {matches: []},
      batchId: this.offlineApplication.travelName,
      operationId: req.visaType.id as DocumentType,
      amountCents: extensionPrice || borderPassPrice || req.visaType.amountCents,
      currency: req.visaType.currency,
      checkoutIsNext: false,
      usageCount: 0,
      createdAt: new Date().toDateString(),
      updatedOn: new Date().toDateString(),
      usageAfter: new Date().toDateString(),
      usageUntil: addMonths(new Date(), 1).toDateString(),
      localUsageUntil: addMonths(new Date(), 1).toDateString(),
      defaultLocalUsageUntilFromServer: this.request.calculateLocalUntil(req.visaType.id as DocumentType, (req.passportType || req.metadata?.PassportType), (req.nationality || req.metadata?.Nationality), req.metadata?.Documents?.PurposeOfVisit),
      paymentType: RequestType.MNTA,
      created_place_id: this.api.userPlaceId,
      metadata: {
        Nationality: req.nationality || req.metadata?.Nationality,
        PassportType: req.passportType || req.metadata?.PassportType,
        PassportNumber: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.PASSPORT_NUMBER, req.formConfig) || req.metadata?.PassportNumber,
        PassportCountry: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.PASSPORT_COUNTRY, req.formConfig) || req.metadata?.PassportCountry,
        LastName: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.LAST_NAME, req.formConfig) || req.metadata?.LastName,
        FirstName: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.FIRST_NAME, req.formConfig) || req.metadata?.FirstName,
        OtherName: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.OTHER_NAME, req.formConfig) || req.metadata?.OtherName,
        CompanionsSize: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.COMPANIONS_SIZE, req.formConfig) || req.metadata?.CompanionsSize,
        BirthDay: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_DAY, req.formConfig) || req.metadata?.BirthDay,
        Gender: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.GENDER, req.formConfig) || req.metadata?.Gender,
        MaritalStatus: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.MARITAL_STATUS, req.formConfig) || req.metadata?.MaritalStatus,
        HomeAddress: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.HOME_ADDRESS, req.formConfig) || req.metadata?.HomeAddress,
        HostName: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.HOST_NAME, req.formConfig) || req.metadata?.HostName,
        Occupation: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.OCCUPATION, req.formConfig) || req.metadata?.Occupation,
        AddressZimbabwe: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.ADDRESS_ZIMBABWE, req.formConfig) || req.metadata?.AddressZimbabwe,
        PreviousConvictionsZim: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.PREVIOUS_CONVICTIONS_ZIM, req.formConfig) || req.metadata?.PreviousConvictionsZim,
        PreviousConvictionsHome: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.PREVIOUS_CONVICTIONS_HOME, req.formConfig) || req.metadata?.PreviousConvictionsHome,
        FundsAvailable: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.FUNDS_AVAILABLE, req.formConfig) || req.metadata?.FundsAvailable,
        FundsAvailableCurrency: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.FUNDS_AVAILABLE_CURRENCY, req.formConfig) || req.metadata?.FundsAvailableCurrency,
        NonOrdinaryPassMission: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.NON_ORDINARY_PASS_MISSION, req.formConfig) || req.metadata?.NonOrdinaryPassMission,
        BorderPass: req.metadata?.BorderPass,
        BorderPassNumber: req.metadata?.BorderPassNumber,
        Reason: req.metadata?.Reason,
        AuthorizedCrossingPoints: req.metadata?.AuthorizedCrossingPoints,
        BorderPassPicture: req.metadata?.BorderPassPicture,
        ExpiryDate: req.metadata?.ExpiryDate,
        IssueDate: req.metadata?.IssueDate,
        ResidentialAddress: req.metadata?.ResidentialAddress,
        DaysRequested: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.DAYS_REQUESTED, req.formConfig) || req.metadata?.DaysRequested,
        ReasonForExtension: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.REASON_FOR_EXTENSION, req.formConfig) || req.metadata?.ReasonForExtension,
        AttestantRelation: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.ATTESTANT_RELATION, req.formConfig) || req.metadata?.AttestantRelation,
        AttestantID: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.ATTESTANT_ID, req.formConfig) || req.metadata?.AttestantID,
        AttestantName: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.ATTESTANT_NAME, req.formConfig) || req.metadata?.AttestantName,
        AttestantPhone: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.ATTESTANT_PHONE, req.formConfig) || req.metadata?.AttestantPhone,
        AttestantEmail: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.ATTESTANT_EMAIL, req.formConfig) || req.metadata?.AttestantEmail,
        AttestantAddress: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.ATTESTANT_ADDRESS, req.formConfig) || req.metadata?.AttestantAddress,
        Documents: {
          PurposeOfVisit: req.formConfig && this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.PURPOSE_OF_VISIT, req.formConfig) || req.metadata?.Documents?.PurposeOfVisit
        }
      },
      offlineParentMethodName: this.offlineApplication.offlineParentMethodName,
      queueId
    };

    this.payment.processOfflineData(this.current);
    this.preparePrintVisa();
    this.preparePrintPersonalData();
    this.preparePrintBorderPass();
    this.loader.loading(false);
  }

  private quitOfflineApplication(): Promise<boolean> {
    return this.queue.warnOfflineOrphan().then((done: boolean) => {
      if(done) {
        this.queue.removeFromQueue({id: this.offlineApplication.queueId}).then(() => {
          this.nav.to('dashboard');
        });
      }
      return done;
    });
  }

  canSeeWarningExtension(): boolean {
    const isValidOperation = documentTypeIsVisaExtAB(this.current.operationId) || documentTypeIsVisaExtC(this.current.operationId);
    if(!isValidOperation) return false;
    const hasValidSeniority = [1, 2, 3].includes(this.seniorityLevel);
    if(!hasValidSeniority) return false;
    if(this.current.subState === RequestSubState.CLOSED || this.current.state === RequestState.USED) return false;
    if(documentTypeIsVisaExtAB(this.current.operationId)) {
      return !this.canBeAcceptedRefused();
    }
    if(documentTypeIsVisaExtC(this.current.operationId)) {
      if(this.seniorityLevel === 3) {
        return !this.canBeAcceptedRefused() && !this.canBeReviewed();
      }
      return !this.canBeReviewed();
    }
    return false;
  }

  editPaymentReference() {
    const dialogInput = [{
      formCtrlName: 'externalId',
      type: 'textarea',
      value: this.current.externalId || '',
      label: 'paymentReference.ask.edit',
      validator: [Validators.required, mustBeDifferentValidator(this.current.externalId)]
    }] as DialogFormInput[];
    return this.loader.loading(true, {type: 'info', message: 'paymentReference.ask.edit', dialogInput}).then((res: any) => {
      if(res?.externalId) {
        return this.api.updatePayment(this.current.id, undefined, res.externalId, undefined, undefined, undefined).then(() => this.getPayment()).catch(() => this.loader.loading(true, {type: 'error', message: 'paymentReference.error.edit'}));
      }
    });
  }

  acceptNotices() {

    const op = OperationType.NOTICES_ACCEPTED;
    const createPaymentParams = (operation: OperationType) => ({
      Operation: operation,
      PaymentReference: this.current.id,
      PaymentIsNotDocument: 'Yes',
      PaymentAmountCents: 0,
      PaymentCurrency: this.current.currency
    });

    const isForced: boolean = false;
    const action = (): Promise<any> => {
      const mainCallParams = [
        this.current.id,
        this.api.userPlaceId,
        new Date(),
        this.current.place_id,
        new Date(this.current.createdAt),
        '',
        createPaymentParams(op),
        this.current.localUsageUntil,
        isForced,
        environment.appVersion.join('.')
      ];
      return this.queue.addToQueue('consumePayment', mainCallParams, 5000, [], this.current.id);
    };

    this.loader.loading(true, {type: 'question', message: this.lang.transform('ask.notices'), btnLabel: this.lang.transform('global.yes'), custom: {closeBtnLabel: this.lang.transform('global.no')}}).then((confirmed: boolean) => {
      if(confirmed) {
        action().then(() => {
          this.api.changeProcessedSession(OperationType.NOTICES_ACCEPTED);
          this.getPayment(true);
        });
      }
    });
  }

  isSitesNonMandatoryExitPicture(): boolean {
    const doc = this.api.userInfo.server.paymentRequests.find(document => document.id === this.current.document.id);
    const sites = doc?.frontendParameters?.sitesNonMandatoryExitPicture;
    return Array.isArray(sites) && sites.includes(this.api.userPlace.id);
  }

  addNote() {
    const note = this.newNote.trim();
    if(!note) return;
    this.api.addNote(this.current.id, note).then((createdNote: PlatformEvent) => {
      this.newNote = '';
      if(createdNote) {
        this.current.eventsNotes.push(createdNote);
      } else {
        const newEvent: PlatformEvent = {
          type: PlatformEventType.PAYMENT_NOTE,
          payment_id: this.current.id,
          place_id: this.current.place_id || null,
          actor_id: this.api.userInfo.id,
          updatedOn: new Date().toISOString(),
          context: JSON.stringify({note}),
          internalIndexedData: null
        };
        this.current.eventsNotes.push(newEvent);
        this.updateDisplayedNotes();
      }
    });
    this.getPayment(false);
  }

  toggleNotes() {
    this.showAllNotes = !this.showAllNotes;
    this.updateDisplayedNotes();
  }

  updateDisplayedNotes() {
    if(!this.current?.eventsNotes?.length) return;
    const sorted = [...this.current.eventsNotes].sort((a, b) => new Date(b.updatedOn).getTime() - new Date(a.updatedOn).getTime());
    this.displayedNotes = this.showAllNotes ? sorted : sorted.slice(0, 2);
  }

  getSortedMovements() {
    const movements = [];
    for(const req of this.travelHistory[this.current.internalReference] ?? []) {
      if(req?.events?.length) {
        for(const evt of req.events) {
          if(evt.internalIndexedData) {
            const parts = evt.internalIndexedData.split('|');
            const op = parts.includes('IN') ? 'IN' : parts.includes('OUT') ? 'OUT' : null;
            if(op) {
              movements.push({
                req: req.id,
                operation: op,
                date: evt.updatedOn
              });
            }
          }
        }
      }
    }
    return movements.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  }

  toggleNotesCollapse() {
    this.showNotesCollapsed = !this.showNotesCollapsed;
  }

  openDuplicatePayment() {
    if(!this.current?.duplicatas?.length) {
      this.loader.loading(true, {type: 'error', message: this.lang.transform('payment.noDuplicatas')});
      return;
    }
    // Find the latest duplicate by createdAt
    const latest = this.current.duplicatas.reduce((prev, curr) => new Date(curr.createdAt) > new Date(prev.createdAt) ? curr : prev);
    if(latest?.id) {
      this.nav.to('admin-request-select/' + latest.id);
    } else {
      this.loader.loading(true, {type: 'error', message: this.lang.transform('payment.noDuplicatas')});
    }
  }

  getExtensionId(event: PlatformEvent): string {
    try {
      const ctx = typeof event.context === 'string' ? JSON.parse(event.context) : event.context;
      return ctx?.payment_id_linked || '';
    } catch {
      return '';
    }
  }

  confirmExtendStay() {
    if((this.current?.eventsExtensions?.length ?? 0) > 0) {
      this.loader.loading(true, {type: 'warn', message: this.lang.transform('extension.alreadyExists.warning'), btnLabel: 'global.confirm'}).then((confirmed) => {
        if(confirmed) {
          this.request.startExtend(this.current, this.current.metadata);
        }
      });
    } else {
      this.request.startExtend(this.current, this.current.metadata);
    }
  }

  protected readonly RequestState = RequestState;
  readonly convertToEpoch = convertToEpoch;
  protected readonly ShortcutAction = ShortcutAction;
  protected readonly ActionState = ActionState;
  protected readonly faSpellCheck = faSpellCheck;
  protected readonly DocsPrintType = DocsPrintType;
  protected readonly ConsumeMode = ConsumeMode;
  protected readonly environment = environment;
  protected readonly DocumentType = DocumentType;
  protected readonly VisaFN = VisaFN;
  protected readonly hasValue = hasValue;
  protected readonly PassportType = PassportType;
  protected readonly DocumentCode = DocumentCode;
  protected readonly UiPermission = UiPermission;
}
